import Dom from '../base/mdom.js';

import Env from '../common/env.js';
import Bus from '../common/bus.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import * as util from '../common/wx_util';

import UI from '../common/uiutil.for_iframe.js';

import PrivilegePopup from '../common/privilegePopup.js';
import PrivilegeDialog from '../common/privilegeDialog.js';
import ReserveDialog from '../common/reserveDialog.js';
import LocalStorage from '../base/localstorage.js';
import ajaxCall from '../common/ajaxcall.js';
import deepClone from '../base/deepclone';
import '../jsbridge/jsapi_log.js';
import '../jsapis/getInstallState.js';
import '../jsapis/queryDownloadTask.js';
import '../jsapis/launch3rdApp.js';
import '../jsapis/launchApplication.js';
import '../jsapis/downloadAppInternal.js';
import '../jsapis/addDownloadTask.js';
import '../jsapis/installDownloadTask.js';
import '../jsapis/pauseDownloadTask.js';
import '../jsapis/resumeDownloadTask.js';
import report11332 from '../report/11332_batch';
import ActionSheet from '../common/actionSheet';

/**
 * 批量高效统一下载预约按钮
 *
 * @param
 * @returns

    eg.
    new Controller({
        // TODO 暂不支持，看后台接口调整 appInfoList: [{app_info: {base_info: {appid:xxx}, download_info: {android_download_info: {xxx}}}}],
        appitemList: [{                     // 后台常用的appitem结构，如后台缺失以下必需字段，请找后台进行补充返回。
                AppID:xxxx,
                DownloadInfo: {
                    DownloadURL: 'xx',      // 必需，后台会根据安卓或ios返回对应的下载链接
                    AndroidApkMd5: 'xxx',   // 必需，安卓下载需要的md5
                    AndroidApkSize: 111     // 必需，安卓下载需要包大小，用于防劫持
                },
                PackageName: 'xxx',         // 必需，包名
                AppType: 0,                 // 必需，游戏类型，用于区分纯app、H5、app混合H5
                VersionCode: 'xxx',         // 可选，后台配置最新的版本号，用于更新逻辑
                HVAppInfo: {                // 可选，H5游戏类型才需要的节点，用于拉起H5游戏
                    LaunchUrl: 'xxxx'
                },

            }, {
                AppID:xxxx, ...
            }
        ],    // 后台统一返回的appitem的数组
        btnList: [{
            appid: 'xxxxx',
            doms:  [document.getElementById('game_btn1')]
        }, {
            appid: 'xxxxx',
            doms:  [document.getElementById('game_btn2'), document.getElementById('game_btn3'), ...]
        }, {
            appid: 'xxx',
            doms: document.getElementByClassName('game_btn_class')
        }...],
        params: {           // 业务相关的参数集合
            sceneid: 233,    // 透传给客户端的sceneid，必传字段，用于客户端区分场景
            ssid   : 2402,   // 来源ssid
            noticeid: 1012345,  //  活动id,
        },
        config: {           // 按钮配置相关集合
            // IOS配置
            downloadInternal      : true,			 			// 是否采用内置Appstore页面下载
            iosDefaultText        : '进入游戏',					// IOS不能判断是否安装了游戏的按钮文案

            // 安卓配置
            installText           : '安装',						// 安卓判断游戏已经下载但是还没安装的按钮文案
            downIngText           : '下载中',					// 安卓判断出游戏正在下载的按钮文案
            pauseText             : '恢复',					// 安卓判断出游戏已暂停下载的按钮文案
            androidStartText      : '启动',			// 安卓判断出游戏已经安装的按钮文案
            androidDownText       : '下载',			// 安卓判断出游戏尚未安装且尚未下载的按钮文案
            androidUpdateText     : '更新',					    // 安卓判断出游戏已安装但不是最新版本的按钮文案
            checkingText          : '校验中',                   // 安装包正在校验
            todoText              : '敬请期待',                 // 不明状态
            tryPlayText           : '试玩',                     // 试玩游戏

            needProgress          : false,						// 是否有进度条逻辑

            // H5游戏配置
            h5StartText           : '启动游戏',					// H5游戏按钮文案

            // wordDomClassName      : 'word__text',              // 渲染按钮文字的节点，具体根据个人需要
            needBtnTextAutoUpdate : true,                      // 是否需要按钮文字自动更新（不包含进度条样式，进度条样式比较复杂，使用者在回调中自己解决）

            // 一些关键节点的actionFlag
            actionFlag: {
                canPauseDownload: true                  // 是否可以中途暂停下载,默认是true
            },

            forceQueryAll: false                // 是否每次增加新游戏信息时都主动查询游戏状态

        },
        callback: {
            // 有关下载\启动等的回调
            action: function({ appitem, dom, actionid, actionKey }) {
                // actionKey: 'download', 'install', 'launch', 'tryPlay', 'update','reserve', 'confirmWifi', 'refuseWifi'
                // actionid: 23, 22, ...
            },
            // 需要progress回调执行，必须在config中传入needProgress: true
            progress: function({ appid, progress, doms}) {
                // progress: 1- 99%
            },
            textChange: function({ doms, appitem, status, btnWord, STATUS}) {

            }
        }
    });

    Controller.append({
        appitemList: [{AppID:xxxx, ...}, {AppID:xxxx, ...}],    // 后台统一返回的appitem的数组
        btnList: [{
            appid: 'xxxxx',
            doms:  [document.getElementById('game_btn1')]
        }, {
            appid: 'xxxxx',
            doms:  [document.getElementById('game_btn2'), document.getElementById('game_btn3'), ...]
        }, {
            appid: 'xxx',
            doms: document.getElementByClassName('game_btn_class')
        }...]
    })

    // 重设了sceneid
    Controller.reset({
        sceneid: xxx
    })

 */

var exportData = {};
if(!Env.isCSR) {

var top         = Dom.window;
    
// 记录当前页面状态已经开启的wifi预下载列表，避免重复点击请求
if(!window.__reserveWifiList__) {
    window.__reserveWifiList__ = [];
}

var Util = util.extend(util, {
    isArray: function(target) {
        return target.constructor == Array;
    },
    isElementInViewport: function(el, height, right) {
        var rect = el.getBoundingClientRect();

        var width_st = right || rect.width / 2,
            height_st = height || rect.height / 2;

        var innerHeight = window.innerHeight,
            innerWidth = window.innerWidth;

        var clientHeight = document.documentElement.clientHeight,
            clientWidth = document.documentElement.clientWidth;

        // 只做高度判断
        return (
                rect.height > 0
            &&  rect.width > 0
            && (   (rect.top >= 0 && rect.top <= innerHeight - height_st)
                || (rect.bottom >= height_st && rect.bottom <= innerHeight)  )
            &&  (  (rect.left >= 0 && rect.left <= innerWidth - width_st)
                || (rect.right >= width_st && rect.right <= innerWidth)  )
        )
    },
    debounce: function(callback, t, context) {
        var timer;

        return function () {
            var args = arguments;

            if (timer) {
                return;
            }

            timer = setTimeout(function () {
                callback.apply(context, args);
                timer = null;
            }, t)
        }
    },
    log: function() {
        var args = arguments;
        var logInfo = window.logInfo || logInfo;

        try {
            if ( window.logInfo || logInfo ) {
                logInfo.apply(window, args)
                // console.log.apply(null, args);
            } else {
                console.log.apply(null, args);
            }
        } catch(e) {
            console.log(e);
        }
    },
    uuid: function() {
        var d = Date.now();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
          d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
      }
});

function NONE() {}


var STATUS = {
    'un_ready'      : 'un_ready',
    'un_download'   : 'un_download',
    'un_reserve'    : 'un_reserve',
    'try_play'      : 'try_play',
    'todo'          : 'todo',
    'reserved'      : 'reserved',
    'h5'            : 'h5',
    'h5_and_app'    : 'h5_and_app',
    'installed'     : 'installed',
    'downloaded'    : 'downloaded',
    'downloading'   : 'downloading',
    'checking'      : 'checking',
    'un_update'     : 'un_update',
    'pause'         : 'pause',
    'install'       : 'install',
    'wait_wifi'     : 'wait_wifi'
}

var Config = {
    launchIOSAppText      : 'WX_GameCenter',			// 启动IOS APP传的自定义参数
    launchAndroidAppText  : 'WX_GameCenter', 			// 启动Android APP传的自定义参数
};

var DefaultConfig = {
    downloadInternal      : true,			 			// 是否采用内置Appstore页面下载
    iosDefaultText        : '进入',					// IOS不能判断是否安装了游戏的按钮文案
    iosReserveText        : '预约',
    iosReservedText       : '已预约',


    // 安卓配置
    installText           : '安装',						// 安卓判断游戏已经下载但是还没安装的按钮文案
    downIngText           : '下载中',					// 安卓判断出游戏正在下载的按钮文案
    pauseText             : '恢复',					// 安卓判断出游戏已暂停下载的按钮文案
    androidStartText      : '启动',			// 安卓判断出游戏已经安装的按钮文案
    androidDownText       : '下载',			// 安卓判断出游戏尚未安装且尚未下载的按钮文案
    androidUpdateText     : '更新',					    // 安卓判断出游戏已安装但不是最新版本的按钮文案
    checkingText          : '校验中',                   // 安装包正在校验
    todoText              : '敬请期待',                 // 不明状态
    tryPlayText           : '试玩',                     // 试玩游戏
    androidReserveText    : '预约',
    androidReservedText   : '已预约',
    waitWifiText          : '等待Wi-Fi',

    // H5游戏配置
    h5StartText           : '启动',					// H5游戏按钮文案

    // wordDomClassName      : 'word__text',              // 渲染按钮文字的节点
    needBtnTextAutoUpdate : true,

    // 强制查询所有的游戏状态，而不是根据可见与否去查询
    forceQueryAll         : false,

    actionFlag            : {
        canPauseDownload  : true        // 是否可以中途暂停下载,默认是true
    }
}
AppWareHouse.instance = null;
// 将appMap
function AppWareHouse(){

    if ( AppWareHouse.instance ) {
        return AppWareHouse.instance;
    }

    // 主仓库, 以appid为key
    this.allAppMap = {};

    // 子配置仓库，以controllerId为key
    this.controllerMap = {}

    // 不需要监听
    // this.listenEvent();

    AppWareHouse.instance = this;

    return AppWareHouse.instance;
}

AppWareHouse.prototype.register = function(pack){
    var controllerMap = this.controllerMap;
    var id       = pack.id,
        config   = pack.config,
        callback = pack.callback;

    if ( !controllerMap[id] ) {
        controllerMap[id] = {
            config: config,
            callback: callback,
        }
    }
}

var KEY = {
    batchQueryAppStatus: 'batchQueryAppStatus',
    queryAppStatus: 'queryAppStatus',
    queryAppStatusDone: 'queryAppStatusDone',
    statusReady: 'statusReady'
}

// AppWareHouse.prototype.listenEvent = function(){
//     var that = this;
//     var appidList = [];
//     var isThrotting = false;

//     var throttleFn = Util.debounce(function(){
//         // Util.log('batch status list change', appidList);

//         that.queryAppListStatus(appidList);

//         appidList = [];
//         isThrotting = false;
//     }, 100, that);

//     Bus.on(KEY.queryAppStatus, function(pack){
//         if ( appidList.indexOf(pack.appid) == -1 ) {
//             appidList.push(pack.appid)
//         }

//         if ( !isThrotting ) {
//             throttleFn();
//             isThrotting = true;
//         }
//     })
// }


AppWareHouse.prototype.queryAppListStatus = function(appidList, callback){
    var that = this;
    var appitemList = [];

    appidList.forEach(function(appid) {
        if ( that.allAppMap[appid] && that.allAppMap[appid].appitem) {
            var appitem = that.allAppMap[appid].appitem;
            appitemList.push(appitem)
        }

    })


    // console.warn('queryAppListStatus', appidList, appitemList, new Date().getTime())
    getAppListDetailStatus(
        appitemList,
        function(res){
            // console.warn('queryAppListStatus res', res)
            // console.warn('queryAppListStatus end', appidList, appitemList, new Date().getTime())
            // for(var appid in res) {
            //     var statusFSM = that.allAppMap[appid].statusFSM;
            //     var progress = reStoreGameProgress(appid);

            //     statusFSM.setStatus(res[appid]);
            //     Bus.trigger(KEY.queryAppStatusDone, {
            //         appid: appid,
            //         status: res[appid]
            //     })
            // }

            callback(res);
        }
    );
}

AppWareHouse.prototype.append = function(pack) {
    var that = this;
    var id = pack.id || '';
    var appitemList = pack.appitemList || [];

    appitemList.forEach(function(appitem) {
        var appid = appitem.AppID;

        that.checkUpdateApp({
            appid   : appid,
            appitem : appitem
        })

    })
}

AppWareHouse.prototype.queryApp = function(obj){
    var that = this;
    var allAppMap = that.allAppMap;

    var appitem     = obj.appitem,
        callback    = obj.callback;

    var appid       = obj.appid || appitem.AppID;

    that.checkUpdateApp({
        appid: appid,
        appitem: appitem
    })

    var statusFSM   = allAppMap[appid].statusFSM;


    if ( allAppMap[appid] ) {
        var appitem = allAppMap[appid].appitem;

        getAppDetailStatus(appitem, function(res){

            var appInfo = allAppMap[appid];
            var statusFSM = appInfo.statusFSM;

            if ( !statusFSM.isStatusReady() ) {
                statusFSM.setStatus(res);
            }

            var ret = {
                appid: appid,
                status: statusFSM.getStatus(res),
                progres: reStoreGameProgress(appid)
            }

            callback(ret)
        })

        return {
            appid: appid,
            status: statusFSM.getStatus(),
            progres: reStoreGameProgress(appid)
        };
    }



    return {
        appid: appid,
        status: STATUS.un_ready
    }
}

AppWareHouse.prototype.checkUpdateApp = function(obj) {
    var that  = this;
    var allAppMap = that.allAppMap;

    var appid = obj.appid,
        appitem = obj.appitem;

    if ( !(appid in allAppMap) ) {
        allAppMap[appid] = {
            appitem: appitem,
            statusFSM: new AppStatusMachine({
                appid   : appid,
                appitem : appitem,
                status  : STATUS.un_ready,
                statusChangeCbk: function(res) {
                    that.statusChangeCbk(res)
                },
                statusReadyCbk: function(res) {
                    // that.statusReadyCbk(res);
                },
                progressChangeCbk: function(res) {
                    that.progressChangeCbk(res);
                },
            })
        };
    } else {
         // 已经存在appitem对象，如果有更新,使用最新传入的，并且更新状态
         var oldAppitem = allAppMap[appid].appitem,
            statusFSM  = allAppMap[appid].statusFSM;

        // 对特征进行对比, 更新appitem
        if ( appitem && !isTwoAppitemSame(oldAppitem,appitem) ) {
            statusFSM.resetAppItem(appitem);
            allAppMap[appid].appitem = appitem;
        }
    }
}


AppWareHouse.prototype.queryAppList = function(obj) {
    var that = this,
        appidList   = obj.appidList   || [],
        appitemList = obj.appitemList || [],
        callback    = obj.callback;
    var allAppMap = that.allAppMap;
    var outAppidList = [];

    // 查询时发现现有仓库不含有该游戏信息，初始化
    appitemList.forEach(function(appitem) {

        if ( !appitem ) {
            Util.log('AppWareHouse queryAppList exist empty appitem');
            return;
        }

        var appid = appitem.AppID;

        that.checkUpdateApp({
            appid: appid,
            appitem: appitem
        });

        outAppidList.push(appid);
    })

    var finalAppidList = [];
    appidList.forEach(function(appid, index){
        if ( !(appid in allAppMap) ) {
            console.error('有未传入appitem的游戏正在进行查询', appid);
        } else {
            finalAppidList.push(appid)
        }
    })

    var ret = [];
    that.queryAppListStatus(appidList, function(res){
        for ( var appid in res ) {
            var appInfo = allAppMap[appid];
            var statusFSM = appInfo.statusFSM;

            if ( res[appid] != STATUS.un_ready ) {
                statusFSM.setStatus(res[appid]);
            }

            // [{appid: xxx, status: xxx, progres: x}]
            ret.push({
                appid   : appid,
                status  : statusFSM.getStatus(),
                progress: reStoreGameProgress(appid)
            })
        }


        callback && callback(ret);
    })
}



AppWareHouse.prototype.statusChangeCbk = function(res){
    var that = this,
        controllerMap = that.controllerMap;

    for ( var controllerId in controllerMap ) {
        var controller = controllerMap[controllerId];

        controller.callback.statusChangeCbk(res);
    }
}

AppWareHouse.prototype.progressChangeCbk = function(res){
    var that = this,
        controllerMap = that.controllerMap;

    for ( var controllerId in controllerMap ) {
        var controller = controllerMap[controllerId];

        controller.callback.progressChangeCbk(res);
    }
}


AppWareHouse.prototype.getAppItem = function(appid){
    if ( this.allAppMap[appid] ) {
        return this.allAppMap[appid].appitem;
    }

    Util.log('AppWareHouse get appitem but empty:', appid);
    return null;
}


function Controller(opt) {
    var appitemList = opt.appitemList || [],
        btnList     = opt.btnList     || [],
        config      = opt.config      || {},
        params      = opt.params      || {},
        callback    = opt.callback    || {};

    // 将配置都放在Config统一管理
    this.config     = Util.extendDeep(Config, DefaultConfig, config, params);

    this.id         = Util.uuid();


    // 单例
    // if ( typeof Controller.instance === 'object' ) {

    //     Controller.instance.append({
    //         appitemList: appitemList,
    //         btnList    : btnList
    //     })

    //     // 增加回调函数
    //     Controller.instance.addCallback(callback)


    //     return Controller.instance;
    // }

    // 校验参数
    if ( config.needBtnTextAutoUpdate ) {
        if ( !config.wordDomClassName ) {
            // console.warn('按钮文案将自动更新，请传入config.wordDomClassName，否则将默认传入dom为文案修改对象节点');
        }
    } else {
        // console.warn('按钮文案将不会自动更新，请在回调函数中完成对应的文案、样式修改。如需要自动更新，请传入needBtnTextAutoUpdate: true');
    }
    if ( !params.sceneid ) {
        // console.warn('请传入params.sceneid，将参数将在调用下载api时透传给客户端进行上报，还是有点重要的');
    }
    // console.warn('本库使用了wxBridge.verify进行api校验，调用者请外面调用确保一致，必须使用wxBridge.verify, 否则将会可能导致一方回调不执行的问题');

    var that = this;

    this.allAppMap = {};

    this.params     = params;
    this.progressCbks   = this.progressCbks   || [];
    this.actionCbks     = this.actionCbks     || [];
    this.textChangeCbks = this.textChangeCbks || [];

    this.addCallback(callback);

    this.callback   = {
        progress: function(res){
            that.progressCbks.forEach(function(cbk) {
                cbk(res)
            })
        },
        action: function(res){
            that.actionCbks.forEach(function(cbk) {
                console.log('action cbks')
                cbk(res)
            })
        },
        textChange: function(res){
            that.textChangeCbks.forEach(function(cbk) {
                cbk(res)
            })
        }
    };

    this.appWareHouse = new AppWareHouse();

    this.appWareHouse.register({
        id      : this.id,
        config  : this.config,
        callback: {
            statusChangeCbk: this.statusChangeCbk.bind(this),
            statusReadyCbk : this.statusReadyCbk.bind(this),
            progressChangeCbk: this.progressChangeCbk.bind(this)
        }
    })


    this.throttleSetBtnWordAndProgressFuncMap = this.throttleSetBtnWordAndProgressFuncMap || {};
    this.throttleSetBtnWordAndProgress = function(id) {
        if ( !that.throttleSetBtnWordAndProgressFuncMap[id] ) {
            that.throttleSetBtnWordAndProgressFuncMap[id] = Util.throttle(
                this.setBtnWordAndProgress,
                100,
                that
            )
        }
        return that.throttleSetBtnWordAndProgressFuncMap[id]
    }

    this.listenEvent();

    this.append({
        appitemList : appitemList,
        btnList     : btnList
    });

    // 向客户端传递信息，更新未验证问题
    sendAppItemToClient(appitemList || []);

    // 单例
    // Controller.instance = this;

    return this;
}

function IsHasTheSameFunc(arr, func) {
    for ( var i = 0; i < arr.length; i++ ) {
        if ( arr[i].toString() == func.toString() ){
            return true
        }
    }

    return false;
}

function sendAppItemToClient(list) {
    if(!window.__appitem_send_version_list__) {
        window.__appitem_send_version_list__ = []
    }

    // 蜡烛人
    let whiteList = ['wxa9bfa582cdb099fb'];

    list.forEach(function(item) {
        if(item && item.AppID && (item.new_game_desc || whiteList.indexOf(item.AppID) > -1) && window.__appitem_send_version_list__.indexOf(item.AppID) === -1) {
            window.__appitem_send_version_list__.push(item.AppID);

            wxBridge.verifyJsapi(['getGameCommInfo'], function(ret) {
                wxBridge.invoke('getGameCommInfo', {
                    cmd: 10011,
                    param:{
                        appid: item.AppID,
                        version: item.biz_version || 0
                    }
                }, function(res) {
                })
            })
        }
    })
}

Controller.getAppItemByAppId = function (appidList = [], callback, needSubscribe = true) {
    if(!appidList.length) {
        return callback && callback()
    }

    ajaxCall(
        '/cgi-bin/gamewap/batchgetgamebase',
        JSON.stringify({ appid_list: appidList, need_is_subscribed: needSubscribe, method: 'POST' }),
        function(res) {
            callback && callback(res);
        }, function (res) {
            callback && callback()
        }
    )
}

Controller.prototype.addCallback = function(callback) {
    callback = callback || {};

    if (    callback.progress
        && !IsHasTheSameFunc(this.progressCbks, callback.progress) ) {
        this.progressCbks.push(callback.progress)
    }
    if (    callback.action
        && !IsHasTheSameFunc(this.actionCbks, callback.action) ) {
        this.actionCbks.push(callback.action)
    }
    if (    callback.textChange
        && !IsHasTheSameFunc(this.textChangeCbks, callback.textChange) ) {
        this.textChangeCbks.push(callback.textChange)
    }

    return this;
}

Controller.prototype.listenEvent = function() {
    var that = this;
    var allAppMap = that.allAppMap;

    wxBridge.on(
        'activity:state_change',
        function(res) {
            Util.log('activity:state_change', res);
            console.warn('activity:state_change', res);
            if ( res.state === 'onResume' ) {
                if ( !Env.isiOS ) {

                    Util.log('activity resume')

                    // 将所有游戏都切换成未初始化状态，重新查询。
                    // for ( var appid in allAppMap ) {
                    //     allAppMap[appid].statusFSM.setStatusInited(false);
                    // }

                    // 安卓下下载游戏触发resume，主动查询游戏状态，但由于客户端未完成启动下载动作，查询的结果为未下载，导致状态异常
                    // fix：延迟300ms查询，确保游戏状态正常
                    // settimeout 300ms不够，延迟将导致状态混乱，只能先保持原状，等客户端自己进行修复。
                    // setTimeout(function() {
                        // that.setVisableDetailAppState({
                        //     refreshAllVisableApp: true
                        // });

                        that.initVisableDetailAppState({
                            refreshAllVisableApp: true,
                            forceQueryAll:  that.config.forceQueryAll
                        })

                    // }, 200);
                }
            }
        }
    );

    var throttleInitVisableDetailAppState = Util.throttle(
        that.initVisableDetailAppState,
        500,
        that
    );

    window.addEventListener('scroll', throttleInitVisableDetailAppState);

}

Controller.prototype.initVisableDetailAppState = function(opt){
    var that = this;
    var visableAppIDList = that.getVisableAppList(opt),
        visableAppitemList = [],
        visableAppInfoList = [];

        opt = opt || {}

    visableAppIDList.forEach(function(appid){
        visableAppitemList.push(that.allAppMap[appid].appitem);
        visableAppInfoList.push(that.allAppMap[appid]);
    })

    Util.log('initVisableDetailAppState visableAppIDList', visableAppIDList);
    Util.log('initVisableDetailAppState visableAppInfoList', visableAppInfoList);


    if ( visableAppitemList.length ) {
        that.appWareHouse.queryAppList({
            id: that.id,
            appidList  : visableAppIDList,
            appitemList: visableAppitemList,
            refresh: opt.refreshAllVisableApp || false,
            callback: function(res){
                res.forEach(function(app){
                    var appid = app.appid;

                    if ( app.status != STATUS.un_ready) {
                        that.allAppMap[appid].status = app.status;

                        that.statusReadyCbk(app)
                    }

                })
            }
        })
    }

}

// 初始化单个游戏状态
Controller.prototype.initDetailAppState = function(appid){
    var that = this;

    that.queryAppInfo(appid, function(app){
        if (app && appid == app.appid) {
            if ( app.status != STATUS.un_ready ) {
                that.allAppMap[appid].status = app.status;

                that.statusReadyCbk(app);
            }
        }
    })
}

Controller.prototype.forceInitApp = function(appid){
    var that = this;

    that.initDetailAppState(appid)
}


Controller.prototype.append = function(pack) {
    var that        = this;
    var allAppMap   = that.allAppMap;
    var appitemList = pack.appitemList || [],
        btnList     = pack.btnList     || [];

    console.log('append begin', that.id, appitemList)
    appitemList.forEach(function(appitem) {
        var appid = appitem.AppID;

        if ( !allAppMap[appid] ) {
            that.initAppInfo({
                appid: appid,
                appitem: appitem
            })
        } else {
            var oldAppitem = allAppMap[appid].appitem;
            if ( !isTwoAppitemSame(appitem, oldAppitem) ) {
                allAppMap[appid].appitem = appitem;
                console.log('append change ing', that.id, oldAppitem, appitem)

            }
        }
    })
    console.log('append after', that.id, that.allAppMap)




    // btn不在仓库处理，controller自己单独处理
    btnList.forEach(function(btnInfo) {
        var appid = btnInfo.appid;
        var btn_infos = btnInfo.doms || [],
            domAppitem = btnInfo.appitem;

        if ( !appid ) {
            Util.log('btn invalid appid', appid);
            return;
        }

        // 本地没有该游戏信息，从仓库读取初始化
        if ( !(appid in allAppMap) ) {
            that.initAppInfo({
                appid: appid
            })

        }

        if ( btn_infos.length > 0 && !(appid in allAppMap) ) {
            Util.log('已传入'+appid+'的按钮信息，但未传入对应的appitem。');
            console.warn('已传入'+appid+'的按钮信息，未传入对应的appitem。');
            return;
        }


        if ( !domAppitem ) {
            domAppitem = allAppMap[appid].appitem;
        }

        var exist_btn_infos = allAppMap[appid].doms || [];     // 已有的doms

        btn_infos = Array.prototype.slice.call(btn_infos, 0);   // 兼容btnList可能是HTMLcollection
        btn_infos.forEach(function(btn_dom) {

            if ( !btn_dom ) {
                return;
            }

            // 当前按钮队列中不存在的才插入
            var isNewDom = true;
            exist_btn_infos.forEach(function(btnInfo){
                if ( btnInfo.dom == btn_dom ) {
                    isNewDom = false;
                }
            })

            if ( isNewDom ) {
                var btnInfo = {
                    dom     : btn_dom,
                    appitem : domAppitem || {},
                    inited  : false
                };
                exist_btn_infos.push(btnInfo);

                // 拿到初次渲染的状态
                var rendFirstStatus = allAppMap[appid].status;

                if ( rendFirstStatus == STATUS.un_ready ) {
                    // 有效appitem下去查询
                    if ( domAppitem && domAppitem.AppID ) {
                        rendFirstStatus = getRoughAppStatus(domAppitem)
                    }
                }

                that.setBtnWord({
                    appid: appid,
                    doms : [btn_dom],
                    status: rendFirstStatus
                })

                that.bindBtnClickEvent(appid, btnInfo); // 按钮需要绑定事件
            }
        });
    });

    // // IOS下不需要调jsapi去获取当前详细的状态
    // if ( !Env.isiOS ) {
    //     // 在下一个micro任务进行，dom有可能没准备好
    //     setTimeout(function() {
    //         that.setVisableDetailAppState({
    //             forceQueryAll: that.config.forceQueryAll
    //         });
    //     }, 0)
    // }

    that.appWareHouse.append({
        id: that.id,
        appitemList: appitemList,
    })

    setTimeout(function(){
        that.initVisableDetailAppState({
            forceQueryAll: that.config.forceQueryAll || false
        });
    }, 0)

    return that;
}



// 重设参数
Controller.prototype.reset = function(opt) {
    var that = this;
    var config      = opt.config || {},
        params      = opt.params || {};

    that.config     = Util.extendDeep(that.config, config, params);

    return that;
}

var NecessaryAPIs = [
    'pauseDownloadTask',
    'resumeDownloadTask',
    'downloadAppInternal',
    'addDownloadTaskStraight',
    'launchApplication',
    'openUrlWithExtraWebview',
];

var ActionIDMap = {
    'statusChecking': 20011, // 74,   // 游戏状态正在查询中

    'launchH5'      : 40,
    'reserve'       : 45,
    'tryPlay'       : 55,
    'launchApp'     : 22,
    'install'       : 44,
    'download'      : 23,
    'confirmWifi'   : 58,
    'refuseWifi'    : 59,
    'update'        : 54,
    'reserveWifi'   : 82,
    'un_reserve'    : 93,

    'downloading'   : 20012, //75,
    'pauseDownload' : 20013, // 76,
    'resumeDownload': 20014, // 77,
    'checking'      : 20015, // 78,   // 下载完成校验中
    'todo'          : 20016, // 79,
    'reserved'      : 20017, // 已预约下的点击
};

Controller.prototype.forceQueryWareHouse = function(appid){
    var that = this;
    var appitem = (that.allAppMap[appid] || {}).appitem;

    // 如果发现本控制器没有，初始化
    if ( !that.allAppMap[appid] ) {
        that.initAppInfo(appid);
    }

    return that.appWareHouse.queryApp({
                appid: appid,
                appitem: appitem,
                callback: function(res) {
                    var appid = res.appid;

                    if ( res.status != STATUS.un_ready) {
                        that.allAppMap[appid].status = res.status;

                        that.statusReadyCbk(res)
                    }

                }
            });

}

// 当前游戏状态执行下一步动作
Controller.prototype.doAction = function(appid, params) {
    var that = this;
    var config     = deepClone(that.config, false);
    params         = params || {};
    var btn_dom    = params.dom,
        domAppitem = params.domAppitem;
    var appInfo = that.allAppMap[appid],
        // status  = appInfo.statusFSM.getStatus(),
        appitem = domAppitem || appInfo.appitem;
    var status          = that.forceQueryWareHouse(appid).status,
        isStatusReady   = (status != STATUS.statusChecking && status != STATUS.un_ready);

    var result = {
        appitem     : appitem,
        dom         : btn_dom,
        STATUS      : Util.extend({}, STATUS),
        actionKey   : '',
        actionid    : 999,   // 标记为非法动作回调
        ext         : {},    // 一些特有的附带信息返回
        appid       : appitem.AppID || '',
    };
    var actionKey = '';
    var ext       = {};

    btn_dom = btn_dom || null;

    Util.log('app current status', appitem.AppID, status);

    // 此处动作是自动下载触发，用于客户端上报标识
    if ( params.isAutoDownload ) {
        config.isAutoDownload = true;
    }

    // 特殊状态下的触发需要上报当前游戏的状态
    if ( status == STATUS.downloading ) {
        actionKey = 'downloading'
    }
    if ( status == STATUS.statusChecking ) {
        actionKey = 'statusChecking'
    }
    if ( status == STATUS.checking ) {
        actionKey = 'checking'
    }
    if ( status == STATUS.todo ) {
        actionKey = 'todo'
    }
    result.actionKey = actionKey;
    result.actionid  = ActionIDMap[actionKey];

    if(status == STATUS.reserved) {
        actionKey = 'reserved',
        result.actionid  = ActionIDMap[actionKey];
    }

    // 如果安卓的四(五)要素不全，则不可下载或预约
    if(Env.isAndroid && (status == STATUS.un_reserve || status == STATUS.un_download)) {
        let downloadInfo = appitem.DownloadInfo || {};
        if(!downloadInfo.android_pkg_version || !downloadInfo.android_privacy_url || !downloadInfo.android_privileges_url || !downloadInfo.android_developer) {
            UI.alert('当前不支持' + (status == STATUS.un_reserve ? '预约' : '下载') + '该游戏');
            return;

        }
    }

    if ( actionKey ) {

        // 下载需要附加下载中的信息
        if ( actionKey == 'downloading' ) {
            ext = {
                progress: reStoreGameProgress(appid) || 0
            }
        }

        result.ext = ext;

        that.callback.action && that.callback.action(result);
    }


    // 如果游戏正在被查询，需要入栈等待查询结束后执行
    if ( !isStatusReady ) {

        Util.log('Btn Click Wait StatusChecking', appid)

        if ( btn_dom ) {
            appInfo.waitingStack.push(btn_dom)
        } else {
            appInfo.waitingStack.push('forceAction_' + (+new Date()))
        }
        Util.log('waitingStack', appid, appInfo.waitingStack);

        // 特别是如果没有传入可视dom的时候下，需要强行触发一下初始化查询
        that.initDetailAppState(appid);

        return;
    }

    // 同一个游戏已有动作在执行
    if ( appInfo.actionDoing ) {

        Util.log('App has doing action', appid)

        // return;
    }

    appInfo.actionDoing = true;

    // wxBridge.verifyJsapi(
    //     NecessaryAPIs,
    //     function(ret) {

    //         Util.log('appBtn verifyjsapi', ret)

            Action.do({
                appitem : appitem,
                dom     : btn_dom,
                status  : status,
                config  : config,
                callback: function(ret) {
                    // ret为jsapi调取以后 或 人为捏造 的结果 {err_msg: 'jsapiname:ok/fail'}
                    Util.log('[DoAction] After Jsapi:', appid, status, ret)

                    // 结合执行动作前的status和调用的结果来返回结果给回调函数
                    // 同时扭转状态
                    actionKey = '';
                    ext       = {};


                    if (    status == STATUS.h5
                        ||  isRetSuccAboutJsapiOf(ret, 'launchH5')  ) {
                        actionKey = 'launchH5';
                    }
                    // 安卓下的下载
                    if (    isRetSuccAboutJsapiOf(ret, 'addDownloadTask')
                        ||  isRetSuccAboutJsapiOf(ret, 'addDownloadTaskStraight')   )
                    {
                        if ( status == STATUS.un_download ) {
                            actionKey = 'download';
                        }
                        if ( status == STATUS.try_play ) {
                            actionKey = 'tryPlay';
                        }
                        if ( status == STATUS.un_update ) {
                            actionKey = 'update';
                        }

                        if ( ret.reserve_for_wifi == 1 ) {
                            actionKey = 'reserveWifi';

                            Bus.emit('manualUpdate', {
                                nextStatus  : STATUS.wait_wifi,
                                appitem     : appitem
                            }, true)

                        } else {

                            Bus.emit('manualUpdate', {
                                nextStatus  : STATUS.downloading,
                                appitem     : appitem
                            }, true)

                        }

                    }
                    // ios下的下载, 状态不会进行扭转，ios下没有安卓后面的一串流程，每次点击默认都是走拉起->跳appstore的动作
                    if ( isRetSuccAboutJsapiOf(ret, 'downloadAppInternal') ) {
                        actionKey = 'download';
                    }

                    if (    isRetSuccAboutJsapiOf(ret, 'launchApplication')
                        ||  isRetSuccAboutJsapiOf(ret, 'launch3rdApp')  )
                    {

                        if ( (ret.launchInstallResult || '').indexOf('ok') != -1 ) {
                            actionKey = 'download';
                        } else {
                            actionKey = 'launchApp';
                        }

                    }

                    if (  isRetSuccAboutJsapiOf(ret, 'installDownloadTask') ) {
                        actionKey = 'install'
                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'reserve') ) {
                        actionKey = 'reserve'
                        Bus.emit('manualUpdate', {
                            nextStatus  : STATUS.reserved,
                            appitem     : appitem
                        }, true);
                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'confirmWifiDownload') ) {
                        actionKey = 'confirmWifi'

                        if(Env.isAndroid) {
                            Bus.emit('manualUpdateWifi', {
                                appid: appitem.AppID,
                                status: STATUS.reserved,
                                oldStatus: STATUS.reserved
                            })
                        }
                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'refuseWifiDownload') ) {
                        actionKey = 'refuseWifi'

                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'pauseDownloadTask') ) {
                        actionKey = 'pauseDownload';

                        Bus.emit('manualUpdate', {
                            nextStatus  : STATUS.pause,
                            appitem     : appitem
                        }, true);
                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'resumeDownloadTask') ) {
                        actionKey = 'resumeDownload';

                        if ( ret.reserve_for_wifi == 1 ) {
                            actionKey = 'reserveWifi';

                            Bus.emit('manualUpdate', {
                                nextStatus  : STATUS.wait_wifi,
                                appitem     : appitem
                            }, true);

                        } else {
                            Bus.emit('manualUpdate', {
                                nextStatus  : STATUS.downloading,
                                appitem     : appitem
                            }, true);
                        }


                    }

                    if ( actionKey == 'downloading' ) {
                        var progress = reStoreGameProgress(appid) || 0;
                        ext = {
                            progress: progress
                        }
                    }

                    if ( isRetSuccAboutJsapiOf(ret, 'reservedAlready') ) {
                        actionKey = 'reserved'
                    }

                    if(isRetSuccAboutJsapiOf(ret, 'cancelReserve')) {
                        actionKey = 'un_reserve'
                        Bus.emit('manualUpdate', {
                            nextStatus  : STATUS.un_reserve,
                            appitem     : appitem
                        }, true);
                    }

                    result.actionid = ActionIDMap[actionKey];
                    result.actionKey = actionKey;

                    result.ext       = ext;

                    // 执行回调
                    if ( result.actionid ) {
                        that.callback.action && that.callback.action(result);

                        // 因为wifi预下载合并为预约了，这里强制执行一次预下载的回调，便于业务侧上报
                        if(result.actionid == 45 && Env.isAndroid && appitem.DownloadInfo && appitem.DownloadInfo.is_allow_wifi_autodownload) {
                            that.callback.action && that.callback.action(Object.assign(result, {
                                actionid: 58,
                                actionKey: 'confirmWifi'
                            }));
                        }
                    }

                    // 动作已结束，重设状态
                    appInfo.actionDoing = false;
                }
            })
    //     }
    // )
}

Controller.prototype.autoDownload = function(appid, cbk) {
    var that = this;
    var appitem = (that.allAppMap[appid] || {}).appitem;

    // 如果发现本控制器没有，初始化
    if ( !that.allAppMap[appid] ) {
        that.initAppInfo(appid);
    }

    that.appWareHouse.queryApp({
        appid: appid,
        appitem: appitem,
        callback: function(ret) {
            var appid = ret.appid,
                status = ret.status;
            var canAutoDownload = false;

            // 只有处于当前状态下才可以自动下载
            if (   status == STATUS.un_download
                || status == STATUS.pause
                || status == STATUS.installed
                || status == STATUS.un_update
                || status == STATUS.downloaded
                || status == STATUS.try_play
            ) {
                setTimeout(function(){
                    that.forceAction(appid, {
                        isAutoDownload: true
                    });

                }, 300);

                canAutoDownload = true;
            }

            cbk({
                status: status,
                result: canAutoDownload
            })

        }
    });
}

Controller.prototype.forceAction = function(appid, pack) {
    var that = this;

    Util.log('[forceAction]', appid, pack)

    that.doAction(appid, pack)
}


Controller.prototype.bindBtnClickEvent = function(appid, btnInfo) {
    var that = this;
    var btn_dom = btnInfo.dom,
        appitem = btnInfo.appitem;

    btn_dom.onclick = function() {
        var appInfo = that.allAppMap[appid];
        var status  = appInfo.status;
        var appitem = appInfo.appitem;
        var config = that.params || {}

        Util.log('[BtnClick Begin]', appid, status)

        report11332([{
            iSceneId: config.sceneid || 34,
            iUIArea: config.uiarea || 0,
            iActionId: 25,
            iOpType: 2,
            sGameId: appitem.AppID,
            iPositionId: config.position
        }])

        that.doAction(appid, {
            dom: btn_dom,
            domAppitem: appitem
        });
    }
}

function isRetSuccAboutJsapiOf(ret, jsapiname) {
    var msg = ret.err_msg || '';
    var anotherJsapiName = jsapiname.replace(/[A-Z]/g, function(str) {
        return '_' + String.fromCharCode(str.charCodeAt(0) + (97 - 65))
    })

    return     (   msg.indexOf(jsapiname) != -1
                || msg.indexOf(anotherJsapiName) != -1 )
            && (   msg.indexOf('ok') != -1
                || msg.indexOf('yes') != -1 );
}
function isRetFailAboutJsapiOf(ret, jsapiname) {
    var msg = ret.err_msg || '';
    var anotherJsapiName = jsapiname.replace(/[A-Z]/g, function(str) {
        return '_' + String.fromCharCode(str.charCodeAt(0) + (97 - 65))
    })

    return     (   msg.indexOf(jsapiname) != -1
                || msg.indexOf(anotherJsapiName) != -1 )
            && (   msg.indexOf('fail') != -1 );
}


// 动作集合
// 根据当前的状态，执行对应的操作。
var Action = {
    // 执行入口
    do: function(opt) {
        var appitem = opt.appitem,
            dom     = opt.dom,
            status  = opt.status;
        var callback = opt.callback;
        var actionMap = Action.detail;
        var config   = opt.config;

        if( Env.isMiniprogram() ) {
            util.UI.alert("请前往「发现>游戏」中\n启动游戏", {
                confirmTxt: "知道了"
            })
            return;
        }

        // ios和安卓下通用的
        if (    status == STATUS.todo
            ||  status == STATUS.h5
        ) {
            switch (status) {
                case STATUS.todo:
                    break;

                case STATUS.h5:
                    actionMap['launchH5']({
                        appitem: appitem,
                        config : config,
                        callback: function(ret) {
                            callback(ret)
                        }
                    })
                    break;

                default:
                    break;
            }
            callback(status);
            return;
        }

        var platform = Env.isiOS ? 'ios' : 'android';
        switch (status) {
            case STATUS.un_download:
                actionMap['downloadApp'][platform]({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret);
                    }
                })
                break;

            case STATUS.un_reserve:
                var action = 'reserve';

                // lol手游特殊逻辑
                if (appitem.is_use_follow) {
                    action = 'reserveSp';
                }

                actionMap[action]({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret);
                    },
                });
                break;

            case STATUS.try_play:
                actionMap['tryplay']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret);
                    },
                });
                break;

            case STATUS.reserved:
                // actionMap['reserveWifi']({
                //     appitem: appitem,
                //     config: config,
                //     callback: function(ret) {
                //         callback(ret)
                //     }
                // })
                

                actionMap['cancelReserve']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret)
                    }
                })
                break;

            case STATUS.h5_and_app:
                actionMap['launchAppOrH5']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret);
                    }
                });
                break;

            case STATUS.installed:
                actionMap['launchApp']({
                    appitem: appitem,
                    config : config,
                    callback: function(ret) {
                        callback(ret);
                    }
                })
                break;
            case STATUS.downloaded:
                actionMap['installApp']({
                    appitem: appitem,
                    config : config,
                    callback: function(ret) {
                        callback(ret)
                    }
                });
                break;
            case STATUS.downloading:
                if ( !config.actionFlag.canPauseDownload ) {
                    break;
                }
                actionMap['pauseDownload']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret)
                    }
                })
                break;
            case STATUS.checking:
                // 校验阶段，不允许用户操作
                return;
            case STATUS.un_update:
                actionMap['downloadApp'][platform]({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret);
                    }
                })
                break;
            case STATUS.pause:
                actionMap['resumeDownload']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret)
                    }
                })
                break;
            case STATUS.wait_wifi:
                // 等待wifi下点击，同恢复操作
                actionMap['waitWifi']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret)
                    }
                })
                break;
            case STATUS.install:
                actionMap['installApp']({
                    appitem: appitem,
                    config: config,
                    callback: function(ret) {
                        callback(ret)
                    }
                })
                break;
            default:
                break;
        }

    },
    detail: {
        tryplay: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var appid = appitem.AppID;
            var errTips = {
                no_right: '您暂无试玩资格',
                no_more: '试玩资格已用完',
                no_more_today: '今天资格已用完，明天再来',
                over: '试玩已结束，感谢您的关注',
            };
            var fromType = appitem.resource_from_type || ""; // 试玩增加配置来源：老管理端 or 中控系统

            ajaxCall(
                '/cgi-bin/gamewap/participategametrial?',
                JSON.stringify({ app_id: appid, from_type : fromType, method: 'POST' }),
                function(res) {
                    if ( res && res.errcode != 0 ) {
                        UI.alert(errTips.no_right);
                        return;
                    }
                    if ( res && ('result' in res) ) {
                        switch (res.result) {
                            case 0:
                                Action.detail
                                      .downloadApp['android']({
                                            appitem: appitem,
                                            callback: function(ret) {
                                                callback(ret)
                                            },
                                            config: config
                                        }
                                    )
                                break;
                            case 1:
                            case 3:
                                UI.alert(errTips.no_more);
                                break;
                            case 2:
                                UI.alert(errTips.no_more_today);
                                break;
                            case 4:
                                UI.alert(errTips.over);
                                break;
                            default:
                                UI.alert(errTips.no_right);
                                break;
                        }
                    }
                }
            )
        },
        launchH5: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var launchUrl = appitem.HVAppInfo.LaunchUrl;

            wxBridge.openUrl(
                launchUrl,
                function(res) {
                    callback({
                        err_msg: 'launchH5:ok'
                    });
                }
            );
        },
        downloadApp: {
            ios: function(pack) {
                var appitem = pack.appitem,
                    callback = pack.callback,
                    config  = pack.config || {};

                function downloadApp(appitem, cbk) {
                    var DownloadInfo = appitem.DownloadInfo;
                    var cret         = Env.versionCompare(Env.clientVersion(1), '6.5.5');

                    // 就是能正常使用 downloadAppInternal 的微信版本是 6.5.6
                    var canUseJsapi = (cret > 0);

                    // 不需要内置下载APP，直接跳转到AppStore
                    if (   !config.downloadInternal
                        || !canUseJsapi
                        || Util.getQueryStr('isFromWeappEntry') ) {
                        location.href = DownloadInfo.DownloadURL;
                        cbk({
                            err_msg:'downloadAppInternal:ok'
                        })
                        return;
                    }

                    // 内嵌AppStore下载游戏
                    wxBridge.downloadAppInternal({
                        appUrl: DownloadInfo.DownloadURL
                    }, function(res) {
                        cbk(res);
                    })
                }

                if(typeof appitem.is_authorized !== 'undefined' && !appitem.is_authorized) {
                    report11332([{
                        iSceneId: config.sceneid || 34,
                        iUIArea: config.uiarea || 0,
                        iActionId: 50002,
                        iOpType: 2,
                        sGameId: appitem.AppID,
                        iPositionId: config.position || 0
                    }, {
                        iSceneId: config.sceneid || 34,
                        iUIArea: config.uiarea || 0,
                        iActionId: 23,
                        iOpType: 2,
                        sGameId: appitem.AppID,
                        iPositionId: config.position || 0,
                        sExternInfo: JSON.stringify({
                            before_allow: 1
                        })
                    }])
                }
                
                Action.detail.launchApp({
                    appitem: appitem,
                    config: config,
                    callback: function(res) {
                        if (    res.err_msg.indexOf(':ok') > -1
                            ||  res.err_msg.indexOf(':yes') > -1 )
                        {
                            callback(res);
                            return;
                        } else {
                            downloadApp(appitem, callback);
                        }
                    },
                })

            },
            android: function(pack) {
                var appitem = pack.appitem,
                    callback = pack.callback,
                    config  = pack.config || {};

                var that         = this;  
                var appid        = appitem.AppID;
                var DownloadInfo = appitem.DownloadInfo;

                /**
                * 关注这个魔鬼数字，大于6.5.6，就是在6.5.7版本上
                * addDownloadTaskStraight 才有用
                */
                var cret    = Env.versionCompare( Env.clientVersion(1), '6.5.7');
                var apiName = (  cret >= 0
                            ? 'addDownloadTaskStraight'
                            : 'addDownloadTask'  );
                var downloader_type = typeof DownloadInfo.DownloaderType === 'number'
                                    ? DownloadInfo.DownloaderType
                                    : 1; // 默认为1，走cdn下载。 2018/5/29
                var use_downloader_widget = typeof DownloadInfo.use_downloader_widget == 'boolean'
                                            ? DownloadInfo.use_downloader_widget
                                            : false;
                var download_in_wifi = typeof DownloadInfo.download_in_wifi == 'boolean'
                                            ? DownloadInfo.download_in_wifi
                                            : false;
                var download_type    = config.isAutoDownload ? 3 : 1;   // 区别是自动下载还是手动下载
                var android_section_md5_list = DownloadInfo.android_section_md5_list || [];

                if(config.showDownloadConfirmAlert && Env.isAndroid) {
                    UI.alert(`即将为你下载 ${appitem.Name}`, {
                        confirmCb: function () {
                            downloadHandler();
                        },
                        style: 'twoBtn',
                        closeCb: function () {
                        }
                    })
                }else {
                    downloadHandler();
                }
                
                
                function downloadHandler () {
                    wxBridge.invoke(
                        apiName,
                        {
                            appid               : appid,
                            task_name           : appitem.Name || appitem.PackageName,
                            package_name        : appitem.PackageName,
                            task_url            : DownloadInfo.DownloadURL,
                            file_md5            : DownloadInfo.AndroidApkMd5,
                            task_size           : DownloadInfo.AndroidApkSize,
                            alternative_url     : DownloadInfo.AlternativeDownloadURL,
                            downloader_type     : downloader_type,
                            download_type       : download_type,
                            use_downloader_widget: use_downloader_widget,
                            download_in_wifi    : download_in_wifi,
                            scene	            : config.sceneid,
                            uiarea              : config.uiarea,
                            fileSectionMd5      : android_section_md5_list,
                            extInfo             : encodeURIComponent(JSON.stringify({
                                gameid   : appid,
                                noticeid : parseInt(appitem.Noticeid) || parseInt(Util.getQueryStr('noticeid') || 0) || 0
                            }))
                        },
                        function(res) {
                            // 暂不需要
                            // if ( res.reserve_for_wifi == 1 ) {
                            //     UI.showTips('预约成功',{
                            //         type: 'success',
                            //         moreTip: 'WIFI环境自动下载',
                            //         timeout: 1500
                            //     })
                            // }
    
                            reportAction(appitem, config, res, 'add');
    
                            callback && callback(res);
    
                            // 通知插件浮层，该任务启动插件
                            if (   use_downloader_widget
                                && Env.versionCompare(Env.clientVersion(1), '7.0.3') >= 0
                            ) {
                                Bus.trigger('addToDownloaderWidget', {
                                    appid: appid
                                })
                            }
    
                        }
                    );
                }
            }
        },
        // ios和安卓都是同样的
        launchApp: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

                var appid   = appitem.AppID;
                var DownloadInfo = appitem.DownloadInfo;

                if ( appitem.has_sp_launch_privilege ) {
                    var popUp = new PrivilegePopup({
                        appid: appid,
                        ssid : config.sceneid,
                        success: function(obj){
                            launchAppByApi({
                                extern_info: obj.extern_info
                            })
                        },
                        fail: function(){
                            launchAppByApi()
                        },
                        cancel: function(){

                        }
                    })
                } else {
                    var appList = LocalStorage.getKeyValue('first_launch_game_privilege');
                    // apptype = 4 的应用宝游戏也不拉
                    if((!appList || (appList && appList.indexOf(appid || '') === -1)) && Env.isAndroid && (appitem && appitem.AppType !== 4)) {
                        if(!appList) {
                            appList = []
                        }else {
                            appList = JSON.parse(appList)
                        }
                        appList.push(appid);
                        LocalStorage.setKeyValue('first_launch_game_privilege', JSON.stringify(appList));

                        new PrivilegeDialog({
                            appid: appid,
                            appitem: appitem,
                            scene : '',
                            uiarea: '',
                            success: function(obj) {
                                console.log('success')
                                launchAppByApi();
                            },
                            cancel: function() {
                                console.log('cancel')
                            }
                        })
                    }else {
                        launchAppByApi();
                    }
                }


                function launchAppByApi(pack){
                    var cret    = Env.versionCompare(Env.clientVersion(1), '6.5.5');
                    var apiName = (  cret >= 0
                                ? 'launchApplication'
                                : 'launch3rdApp'  );
                    pack        = pack || {};
                    var extern_info =  pack.extern_info
                                    || appitem.launch_info
                                    || (   Env.isAndroid
                                        ?  config.launchAndroidAppText
                                        :  config.launchIOSAppText
                                    );
                    var params = {
                        'appID'      		 : appid,
                        'messageExt' 		 : extern_info,
                        'extInfo'    		 : extern_info,
                        'showLaunchFailToast': false,
                        'installSchemeUrl'   : DownloadInfo.DownloadURL,
                        'installAction'      : 1,
                    }
                    if( Env.isAndroid && appitem.AppType === 4 && DownloadInfo.android_package_sign ) {
                        params.signature = DownloadInfo.android_package_sign;
                        params.packageName = appitem.PackageName;
                    }
                    wxBridge.invoke(
                        'launchApplication',
                        params,
                        function(res) {
                            callback && callback(res);
                        }
                    );
                }


        },
        // 安装只有安卓才有
        installApp: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var appid = appitem.AppID;
            var download_type = config.isAutoDownload ? 3 : 1;

            wxBridge.queryDownloadTask({
                appid: appid
            }, function(res) {
                if ( res.state.indexOf('_succ') > -1 ) {
                    wxBridge.installDownloadTask({
                        download_id: res.download_id,
                        download_type: download_type
                    },
                    function (res) {
                        callback(res);
                    });
                } else {
                    callback({
                        err_msg: '(installApp -> queryDownloadTask):' + JSON.stringify(res)
                    })
                }
            });
        },
        launchAppOrH5: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var actionMap = Action.detail;

            actionMap['launchApp']({
                appitem: appitem,
                callback: function(res) {
                    if ( res.err_msg.indexOf(':ok') > -1 ) {
                        callback(res);
                        return;
                    } else {
                        actionMap['launchH5'](appitem, callback);
                    }
                },
                config: config
            })
        },
        waitWifi: function(pack){
            var appitem = pack.appitem,
                callback = pack.callback,
                config   = pack.config || {};
            var appid = appitem.AppID;

            wxBridge.queryDownloadTask({
                appid: appid
            }, function(res) {
                if ( res.state.indexOf('default') > -1 ) {
                    Action.detail['downloadApp']['android'](pack)
                }

                if ( res.state.indexOf('pause') > -1 ) {
                    Action.detail['resumeDownload'](pack)
                }
            })
        },
        pauseDownload: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var appid = appitem.AppID;

            wxBridge.queryDownloadTask({
                appid: appid
            }, function(res) {
                if ( res.state.indexOf('downloading') > -1 ) {
                    wxBridge.pauseDownloadTask({
                        download_id: res.download_id
                    },
                    function (res) {
                        callback(res);
                    });
                } else {

                    Util.log('appbtn ', appid, '(pauseDownload -> queryDownloadTask):' + JSON.stringify(res))


                    // 假设当前状态不对，要加兜底
                    if ( res.state.indexOf('pause') > -1) {
                        Action.detail['resumeDownload']({
                            appitem: appitem,
                            callback: callback,
                            config: config
                        });
                    }

                }
            });
        },
        resumeDownload: function(pack) {
            var that = this;
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};

            var appid = appitem.AppID;
            var DownloadInfo = appitem.DownloadInfo;
            var use_downloader_widget = typeof DownloadInfo.use_downloader_widget == 'boolean'
                                            ? DownloadInfo.use_downloader_widget
                                            : false;
            var download_in_wifi = typeof DownloadInfo.download_in_wifi == 'boolean'
                                            ? DownloadInfo.download_in_wifi
                                            : false;
            var download_type = config.isAutoDownload ? 3 : 1; // 自动触发为3，手动为1

            wxBridge.queryDownloadTask({
                appid: appid
            }, function(res) {
                if ( res.state.indexOf('pause') > -1 ) {

                    if(config.showDownloadConfirmAlert && Env.isAndroid) {
                        UI.alert(`即将为你恢复下载 ${appitem.Name}`, {
                            style: 'twoBtn',
                            confirmCb: function () {
                                downloadHandler();
                            },
                            closeCb: function () {
                            }
                        })
                    }else {
                        downloadHandler();
                    }
                    function downloadHandler() {
                        wxBridge.resumeDownloadTask({
                            download_id: res.download_id,
                            use_downloader_widget: use_downloader_widget,
                            download_in_wifi     : download_in_wifi,
                            download_type        : download_type
                        },
                        function (res) {
                            reportAction(appitem, config, res, 'resume');
                            // 暂不需要
                            // if ( res.reserve_for_wifi == 1 ) {
                            //     UI.showTips('预约成功',{
                            //         type: 'success',
                            //         moreTip: 'WIFI环境自动下载',
                            //         timeout: 1500
                            //     })
                            // }
    
                            callback(res);
    
                            // 通知插件浮层，该任务启动插件
                            if ( use_downloader_widget ) {
                                Bus.trigger('addToDownloaderWidget', {
                                    appid: appid
                                })
                            }
                        });
                    }
                } else {

                    Util.log('appbtn', appitem.AppID, '(resumeDownload -> queryDownloadTask):' + JSON.stringify(res))

                    // 假设当前状态不对，要加兜底
                    if ( res.state.indexOf('downloading') > -1) {
                        Action.detail['pauseDownload']({
                            appitem: appitem,
                            callback: callback,
                            config: config
                        });
                    }
                }
            });
        },
        // 预约旧代码，有点鹅心
        reserve: function(pack, type = '预约') {
            var that = this;
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};
            var DownloadInfo = appitem.DownloadInfo;

            var param = {
                "appid"     : appitem.AppID,
                "noticeid"  : parseInt(appitem.Noticeid) || parseInt(Util.getQueryStr('noticeid') || 0) || 0,
                "actid"    : parseInt(appitem.act_id) || parseInt(Util.getQueryStr('act_id') || 0)   || 0,
                "device"    : Env.isiOS ? 1 : 2,
                "clientversion": 0,
                "scene"        : config.sceneid || '',
                "addcard"      : true,       // 新游统一发卡(android+ios)  20190916 by irenedeng。
                method: 'GET'
            };

            var tipsMsg = {
                reserveSucess: type + '成功，游戏上线后将立即通过公众号通知你，并为你发放微信预约礼包',
                reserveSafeSucess: type + '成功',

                reserveWithCardAndWifiSuccess: '礼包卡券已发放，游戏上线后将通过公众号通知你。是否打开上线后WIFI自动下载 ?',
                reserveWithCard: '礼包卡券已发放，游戏上线后将通过公众号通知你',

                reserveWithWifiSuccess: '游戏上线后将通过微信公众号通知你。你是否同意，游戏上线后，在WIFI状态下自动下载该游戏 ?',
            }

            var autoDownload = Env.isAndroid && ( appitem.IsAllowWifiAutoDownload || appitem.is_allow_wifi_autodownload || DownloadInfo.is_allow_wifi_autodownload )

            // if(appitem.IsSubscribed) {
                // console.log('取消' + type);
                // if(autoDownload) {
                //     UI.showLoading('正在开启...');
                //     that.reserveEvent(appitem, callback, config);
                // }
                // return;
            // }

            if(!config.hideReservedDialog) {
                UI.showLoading('正在' + type + '...');
            }

            ajaxCall(
                '/cgi-bin/gamecenterwap/makegameappointment',
                param,
                function (res) {
                    UI.hideLoading('');
                    // if (res.base.ret == 2) {
                    //     UI.alert("预约还未开始");
                    //     return;
                    // } else if (res.base.ret == 3) {
                    //     UI.alert("预约已结束啦");
                    //     return;
                    if (res.errcode === 0) {

                        callback({
                            err_msg: 'reserve:ok'
                        })

                        if(config.noWifiReserve) {
                            // 如果允许wifi下载
                            if (autoDownload) {
                                UI.alert(
                                    res.addcard_result == 0
                                    ? tipsMsg.reserveWithCardAndWifiSuccess
                                    : tipsMsg.reserveWithWifiSuccess
                                , {
                                    confirmCb: function () {
                                    },
                                    title   : type + '成功',
                                    style     : 'oneBtn',
                                    closeCb   : function () {
                                        callback({
                                            err_msg: 'refuseWifiDownload:ok'
                                        })
                                    }
                                });
                            } else {
                                // 正常弹框
                                if ( Env.isiOS ) {
                                    UI.alert(tipsMsg.reserveSafeSucess);
                                } else {
                                    UI.alert( res.addcard_result == 0
                                                ? tipsMsg.reserveWithCard
                                                : tipsMsg.reserveSucess
                                    );
                                }
                            }
                        }else {
                            if(config.hideReservedDialog) return;
                            
                            new ReserveDialog({
                                autoDownload: autoDownload,
                                appitem: appitem,
                                type: type,
                                close: function(checked, hasCard) {

                                    // if(checked) {
                                        // that.reserveEvent(appitem, callback, config, hasCard, true)
                                    // }else {
                                        // callback({
                                        //     err_msg: 'refuseWifiDownload:ok'
                                        // })
                                    // }
                                }
                            })
                        }
                    } else {
                        UI.alert(type + "失败(" + res.errcode + ")");
                    }
                },
                function (res) {
                    UI.hideLoading('')
                    try {
                        UI.alert(type + "失败,网络错误(" + res.errcode + ")");
                    } catch (e) {
                        UI.alert(type + "失败,请稍后重试");
                    }

                }
            );
        },

        // 预约时强制预下载，此方法废弃
        reserveEvent: function (appitem ,callback, config, hasCard, noShowAlert) {
            var confirmWifiParam = {
                data: [{
                    appid   : appitem.AppID,
                    scene_id: config && config.sceneid || 0,
                    notice_id: parseInt(appitem.Noticeid) || parseInt(Util.getQueryStr('noticeid') || 0) || 0,
                    act_id  : parseInt(appitem.act_id)   || parseInt(Util.getQueryStr('act_id') || 0)   || 0,
                    allpath : Util.getQueryStr('allpath'),
                    from_url: location.href.replace(/(uin|key|pass_ticket|abtest_cookie)=[^&]+/g, ''),
                }],
                method: 'POST'
            };

            ajaxCall(
                '/cgi-bin/comm/reportconfirmwifidownload',
                JSON.stringify(
                    confirmWifiParam
                ),
                function(rsp) {
                    UI.hideLoading();
                    if ( rsp.errcode === 0 ) {
                        window.__reserveWifiList__.push(appitem.AppID)
                        callback && callback({
                            err_msg: 'confirmWifiDownload:ok',
                        });

                        if(noShowAlert) {
                            return;
                        }

                        if(hasCard) {
                            UI.alert('已预约WIFI下载，可在我-卡包中查看礼包')
                        }else {
                            ajaxCall(
                                '/cgi-bin/gamewap/getgamebaseextrafor',
                                JSON.stringify({
                                    appid: appitem.AppID,
                                    need_subscribe_info: true
                                }),
                                function(rsp) {
                                    if(rsp.errcode === 0) {
                                        var subscribe_info = rsp.subscribe_info || {}
                                        if(subscribe_info.has_wifi_download_card) {
                                            UI.alert('已预约WIFI下载，可在我-卡包中查看礼包')
                                        }else {
                                            UI.alert('已预约WIFI下载')
                                        }
                                    }else {
                                        UI.alert('已预约WIFI下载')
                                    }
                                },
                                function (err) {
                                    UI.alert('已预约WIFI下载')
                                }
                            )
                        }
                    }
                },
                function(err) {
                    UI.hideLoading();
                    UI.showTips('预约失败('+err.errcode+')', {
                        type: 'fail',
                        timeout: 1000
                    })
                }
            )
        },

        cancelReserve: function (pack, type = '预约') {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};
            console.log('cancel reserve', appitem);


            if(appitem.is_use_follow) {
                type = '关注'
            }

            if(config.showReservedAlert) {
                UI.alert(type + (Env.isAndroid  ? '成功，游戏上线后将在Wi-Fi下自动下载' : '成功，游戏上线后将通知你'));
                return;
            }
            if(config.hideCancelReserve) return;

            ActionSheet.show({
                noFilterXSS  : false, // 默认为false，可不配置
                actionList : [
                    Env.isAndroid ? ("放弃" + type + "后，将不在 Wi-Fi 下为你自动下载该游戏") : ( type + '游戏，可以第一时间收到游戏上线通知'), // 支持富文本，但需将 noFilterXSS 置为 true
                    "放弃" + type,
                ],
                actionCfgList:[{
                    isTitle: true,
                },{
                    isDanger: true
                }],
                clickCbk : function (index) { // 用户选中了第几个选项，index从0开始
                    ajaxCall(
                        '/cgi-bin/gamecenterwap/gamecancelappointment',
                        JSON.stringify({
                            appid: appitem.AppID,
                            scene_id: config && config.sceneid || 0,
                            notice_id: parseInt(appitem.Noticeid) || parseInt(Util.getQueryStr('noticeid') || 0) || 0,
                            act_id  : parseInt(appitem.act_id)   || parseInt(Util.getQueryStr('act_id') || 0)   || 0,
                            allpath : Util.getQueryStr('allpath'),
                            from_url: location.href.replace(/(uin|key|pass_ticket|abtest_cookie)=[^&]+/g, ''),
                        }),
                        function(rsp) {
                            UI.hideLoading();
                            if ( rsp.errcode === 0 ) {
                                report11332([
                                    {
                                        iSceneId: 34,
                                        iUIArea: 3412,
                                        iActionId: 93,
                                        iOpType: 2,
                                        sGameId: appitem.AppID,
                                        iPositionId: 4,
                                    }
                                ]);
        
                                callback && callback({
                                    err_msg: 'cancelReserve:ok',
                                });
                            }
                        },
                        function(err) {
                            UI.hideLoading();
                            UI.showTips('取消失败('+err.errcode+')', {
                                type: 'fail',
                                timeout: 1000
                            })
                        }
                    )
                },
                cancelCbk : function () {     // 用户点击取消或阴影区域，actionsheet隐藏
                }
            })
        },

        reserveWifi: function(pack) {
            var appitem = pack.appitem,
                callback = pack.callback,
                config  = pack.config || {};
            var DownloadInfo = appitem.DownloadInfo;

            var autoDownload = Env.isAndroid && ( appitem.IsAllowWifiAutoDownload || appitem.is_allow_wifi_autodownload || DownloadInfo.is_allow_wifi_autodownload )

            if(window.__reserveWifiList__.indexOf(appitem.AppID) > -1 || appitem.subscribed_wifi_autodownload || config.noWifiReserve) return;

            if(autoDownload) {
                UI.showTips('正在开启...')
                this.reserveEvent(appitem, callback, config)
            }else {
                callback({
                    err_msg: 'reservedAlready: ok'
                })
            }
        },
        reserveSp: function(pack) {
            this.reserve(pack, '关注')
        }
    }
};

function reportAction(appitem, config, res, type) {
    let ext = {}
    ext.err_msg = res.err_msg || '';
    ext.type = type

    if('reserve_for_wifi' in res) {
        ext.reserve_for_wifi = res.reserve_for_wifi
    }

    if(res.err_msg.indexOf('cancel') > -1) {
        report11332([
            {
                iSceneId: config.sceneid || 34,
                iUIArea: config.uiarea || 0,
                iActionId: 61,
                iOpType: 2,
                sGameId: appitem.AppID,
                iPositionId: config.position,
                sExternInfo: JSON.stringify(ext)
            }
        ]);
    }

    report11332([
        {
            iSceneId: config.sceneid || 34,
            iUIArea: config.uiarea || 0,
            iActionId: 20018,
            iOpType: 2,
            sGameId: appitem.AppID,
            iPositionId: config.position,
            sExternInfo: JSON.stringify(ext)
        }
    ]);
}

Controller.prototype.initAppItem = function(appid) {
    var that = this;

    if ( !that.allAppMap[appid] ) {
        that.initAppInfo({
            appid: appid
        });

        return;
    }

    if ( !that.allAppMap[appid].appitem ) {
        that.allAppMap[appid].appitem = that.appWareHouse.getAppItem(appid)
    }
}

Controller.prototype.initAppInfo = function(pack) {
    var that = this;
    var appid = pack.appid;
    var appitem = pack.appitem || that.appWareHouse.getAppItem(appid);
    var status  = pack.status  || STATUS.un_ready;

    that.allAppMap[appid] = {
        appitem     : appitem,
        doms        : [],
        status      : status,
        statusStack : [],
        waitingStack: [],
        actionDoing : false
    };

    return that.allAppMap[appid];
}

// 当游戏状态准备好时的回调函数
// 如果在查询过程中有用户点击动作或调api执行动作产生，现在需要重新出栈执行
Controller.prototype.statusReadyCbk = function(ret) {
    var that = this;
    var appid = ret.appid,
        status = ret.status;

    if ( !that.allAppMap[appid] ) {
        return;
    }

    // 如果此时没有初始化appitem，获取一下
    if ( !that.allAppMap[appid].appitem) {
        that.initAppItem(appid)
    }

    var appInfo = that.allAppMap[appid];


    var items = appInfo.waitingStack;

    if ( items.length ) {
        console.log('statusReady waitingStack', appid, items);
    }

    // if (   ret.status != STATUS.un_ready
    //     && appInfo.status != ret.status
    // ) {
    //     ret.oldStatus = appInfo.status
    //     that.statusChangeCbk(ret);
    // }

    // 状态已准备，按钮文案设置，在准备中的事件出栈执行
    if ( ret.status != STATUS.un_ready ) {
        // 将没有初始化的按钮初始化
        var btnInfos = appInfo.doms;
        var btn_doms = [];


        btnInfos.forEach(function(btnInfo){
            if ( !btnInfo.inited ) {
                btn_doms.push(btnInfo.dom);
                btnInfo.inited = true;
            }
        })

        if ( btn_doms.length > 0  ) {

            that.throttleSetBtnWordAndProgress(appid)({
                appid: appid,
                doms:  btn_doms,
                status: status
            })
        }

        var item;
        while(items.length) {
            item = items.pop();

            if ( typeof item == 'Object' ) {
                item.click();
            } else {
                that.forceAction(appid)
            }
        }

    }




}

Controller.prototype.listenOnDownloaderWidget = function(cbk){
    Bus.on('addToDownloaderWidget', function(ret){
        cbk(ret);
    })
}

// 当有游戏状态发生变化时的回调函数
Controller.prototype.statusChangeCbk = function(ret) {
    // ret:{appid:xxx, status: xx}
    var that = this;
    var appid   = ret.appid,
        status  = ret.status,
        oldStatus = ret.oldStatus;

    if ( !that.allAppMap[appid] ) {
        that.initAppInfo({
            appid: appid,
            status: status
        })
    }

    // 如果此时没有初始化，初始化一下
    if ( !that.allAppMap[appid].appitem ) {
        that.initAppItem(appid)
    }

    var appInfo = that.allAppMap[appid];

    //  将本地的状态更新
    if ( ret.status != appInfo.status ) {
        appInfo.status = ret.status;
        appInfo.statusStack.push(ret.status)
    }

    // 将所有的doms里面的文字进行更新
    var btnInfos = appInfo.doms;
    var btn_doms = [];

    if ( ret.status != STATUS.un_ready ) {

        btnInfos.forEach(function(btnInfo){
            btn_doms.push(btnInfo.dom);
            btnInfo.inited = true;
        })
    }

    // that.setBtnWord(appid, btn_doms);
    that.throttleSetBtnWordAndProgress(appid)({
        appid: appid,
        doms:  btn_doms,
        status: status
    })

    storeGameStatus({
        appid: appid,
        status: status
    })

    // 下载中转到未下载，需要清空游戏的进度状态
    if ( oldStatus == STATUS.downloading ) {
        if ( status == STATUS.un_download ) {
            storeGameProgress({
                appid: appid,
                progress: 0
            })
        }
    }
}

Controller.prototype.setBtnWord = function(pack) {
    var that = this;
    var appid = pack.appid,
        doms = pack.doms,
        status = pack.status;
    var config  = that.config;
    var btnWord = that.getBtnWord(status);
    var btn_doms = doms || [];
    var wordDomClassName = config.wordDomClassName;
    var appitem = that.allAppMap[appid].appitem;

    if(status === STATUS.reserved) {
        // var autoDownload = Env.isAndroid && ( appitem.IsAllowWifiAutoDownload || appitem.is_allow_wifi_autodownload || (appitem.DownloadInfo && appitem.DownloadInfo.is_allow_wifi_autodownload) )
        // if(autoDownload) {
        //     if(appitem.subscribed_wifi_autodownload || window.__reserveWifiList__.indexOf(appid) > -1) {
        //         btnWord = '已开启预下载'
        //     }else {
        //         btnWord = '开启预下载'
        //     }
        // }
    }

    // lol手游特殊逻辑
    if (appitem.is_use_follow ) {
        if ( status == STATUS.un_reserve ) {
            btnWord = '关注'
        }
        if ( status == STATUS.reserved ) {
            btnWord = '已关注'
        }
    }

    var btnInfos = that.allAppMap[appid].doms;
    if ( !btn_doms.length ) {
        btnInfos.forEach(function(btnInfo) {
            btn_doms.push(btnInfo.dom);
        })
    }

    // 自动批量设置按钮文案
    if ( config.needBtnTextAutoUpdate ) {
        btn_doms.forEach(function(btn_dom) {
            if ( wordDomClassName ) {
                var textDoms = [];
                if (btn_dom) {
                    textDoms = btn_dom.getElementsByClassName(wordDomClassName) || [];
                }

                textDoms = Array.prototype.slice.call(textDoms, 0);

                textDoms.forEach(function(textDom) {
                    textDom.innerText = btnWord;
                })
            } else {
                if ( btn_dom ) {
                    btn_dom.innerText = btnWord;
                }
            }
        })
    }

    that.callback.textChange
        && that.callback.textChange({
            appid   : appid,
            doms    : btn_doms,
            appitem : appitem,
            status  : status,
            btnWord : btnWord,
            STATUS  : STATUS
        });

}

Controller.prototype.setBtnWordAndProgress = function(opt) {
    var that = this;
    var appid = opt.appid,
        progress = parseInt(opt.progress),
        doms     = opt.doms,
        status   = opt.status;
    var config   = that.config;

    // console.log(appid, progress, config.needProgress);
    if ( !isNaN(progress) && typeof progress == 'number' && config.needProgress ) {
        that.callback
            && that.callback.progress({
                appid   : appid,
                progress: progress,
                doms    : doms
            })
    } else {

        that.setBtnWord({
            appid: appid,
            doms : doms,
            status: status
        });
    }
}


// 当有游戏的下载进度发生变化
Controller.prototype.progressChangeCbk = function(ret) {
    // ret:{appid: xxx, progress: 10}
    var that = this;
    var appid       = ret.appid,
        progress    = ret.progress;
    var appInfo = that.allAppMap[appid];

    // 如果没有初始化过这个appid的内容，controller忽略掉
    if ( !appInfo ) {
        appInfo = that.initAppInfo({
            appid: appid,
            status: STATUS.downloading
        })
    }

    if ( !appInfo.appitem ) {
        that.initAppItem(appid);
    }

    // 重新设置一下appInfo
    appInfo = that.allAppMap[appid];

    var btnInfos = appInfo.doms || [];
    var doms = [];


    btnInfos.forEach(function(btnInfo){
        doms.push(btnInfo.dom)
    })

    // 安卓客户端的问题：下载中的游戏有可能getquerydownload时state为default
    // 需要进度条走动时强制触发下载中的状态
    Bus.emit('manualUpdate', {
        appitem     : appInfo.appitem,
        nextStatus  : STATUS.downloading
    }, true)

    that.throttleSetBtnWordAndProgress(appid)({
        appid: appid,
        progress: progress,
        doms: doms,
        status: STATUS.downloading
    })

        // 默认进度条99，代表校验中
    if ( progress >= 99 ) {
        Bus.emit('manualUpdate', {
            appitem   : appInfo.appitem,
            nextStatus: STATUS.checking
        }, true);
    } else {
        that.callback.progress && that.callback.progress({
            appid: appid,
            progress: progress,
            doms: doms
        })
    }



    storeGameProgress({
        appid: appid,
        progress: progress,
    });

}

function reStoreGameStatus(appid) {
    try {
        var value = localStorage.getItem("APPBTN_status_"+appid);
        var ret   = JSON.parse(value || '{}').status || '';

        return ret;

    } catch(e) {
        return '';
    }
}
function reStoreGameProgress(appid) {
    try {
        var value = localStorage.getItem("APPBTN_progress_"+appid);
        var ret   = JSON.parse(value || '{}').progress || '';

        return ret;

    } catch(e) {
        return '';
    }
}

function storeGameStatus(obj) {
    var appid       = obj.appid,
        status      = obj.status;

    localStorage.setItem("APPBTN_status_"+appid, JSON.stringify({
        status  : status,
    }))
}

function storeGameProgress(obj) {
    var appid       = obj.appid,
        progress      = obj.progress;

    localStorage.setItem("APPBTN_progress_"+appid, JSON.stringify({
        progress  : progress,
    }))
}



// 根据当前按钮状态，设置文案，执行回调函数
Controller.prototype.getBtnWord = function(status) {
    var that        = this;
    var btnWord     = '';
    var status      = status;

    switch (status) {
        case STATUS.un_download:
            btnWord = that.config.androidDownText;
            if(Env.isiOS) {
                btnWord = that.config.iosDefaultText;
            }
            break;
        case STATUS.un_reserve:
            btnWord = that.config.androidReserveText;
            if ( Env.isiOS ) {
                btnWord = that.config.iosReserveText;
            }
            break;

        case STATUS.try_play:
            btnWord = that.config.tryPlayText;
            break;

        case STATUS.todo:
            btnWord = that.config.todoText;
            break;

        case STATUS.h5:
            btnWord = that.config.h5StartText;
            break;

        case STATUS.reserved:
            btnWord = that.config.androidReservedText;
            if ( Env.isiOS ) {
                btnWord = that.config.iosReservedText
            }
            break;

        case STATUS.installed:
            btnWord = that.config.androidStartText;
            break;

        case STATUS.un_update:
            btnWord = that.config.androidUpdateText;
            break;

        case STATUS.checking:
            btnWord = that.config.checkingText;
            break;

        case STATUS.downloading:
            btnWord = that.config.downIngText;
            break;

        case STATUS.install:
            btnWord = that.config.installText;
            break;

        case STATUS.pause:
            btnWord = that.config.pauseText;
            break;

        case STATUS.downloaded:
            btnWord = that.config.installText;
            break;

        case STATUS.wait_wifi:
            btnWord = that.config.waitWifiText;
            break;
        case STATUS.h5_and_app:
            if ( Env.isiOS ) {
                btnWord = that.config.iosDefaultText || that.config.h5StartText;
            } else {
                btnWord = that.config.h5StartText;
            }

        default:
            break;
    }

    return btnWord;
}

// 对按钮中的文案节点批量修改
Controller.prototype.setBtnText = function(btn_dom, text) {
    var that   = this;
    var config = that.config;
    var wordDomClassName = config.wordDomClassName;


    if ( !config.needBtnTextAutoUpdate ) {
        return false;
    }

    var btnWordDoms = [];
    if ( wordDomClassName ) {
        btnWordDoms = Array.prototype.slice.call(
            btn_dom.getElementsByClassName(wordDomClassName),
            0
        );
    } else {
        btnWordDoms = [btn_dom];
    }

    btnWordDoms.forEach(function(btnWordDom) {
        btnWordDom.innerText = text;
    })

    return true;
}



Controller.prototype.getVisableAppList = function(opt) {
    var that        = this;
    var allAppMap   = that.allAppMap;
    var visableAppIDList = [];
    var allAppIDList     = [];

    opt = opt || {};

    var forceQueryAll    = opt.forceQueryAll,
        refreshAllVisableApp = opt.refreshAllVisableApp;

    // 返回所有的
    if ( forceQueryAll ) {
         for( var appid in allAppMap ) {
             allAppIDList.push(appid)
         }

         return allAppIDList;
    }

    for ( var appid in allAppMap ) {
        var btnInfos = allAppMap[appid].doms || [];
        var doms     = [];

        btnInfos.forEach(function(btnInfo){
            doms.push(btnInfo.dom)
        })
        // var isStatusInited = allAppMap[appid].statusFSM.isStatusInited();

        btnInfos.forEach(function(btnInfo) {
            var dom = btnInfo.dom;

            if (  forceQueryAll
                || (    dom && Util.isElementInViewport(dom)
                    && (refreshAllVisableApp || !btnInfo.inited) )
            ) {
                if ( visableAppIDList.indexOf(appid) == -1 ) {
                    visableAppIDList.push(appid);
                }
            }
        })
    }

    return visableAppIDList;
}

Controller.prototype.queryAppInfo = function(appid, cbk){
    var that = this;
    var appitem;

    that.appWareHouse.queryAppList({
        appidList: [appid],
        callback: function(res) {
            var ret = res[0] || {};

            cbk(ret);
        }
    })
}

Controller.prototype.queryAppListInfo = function(appidList, cbk) {
    var that = this;
    var appitemList = [],
        allAppMap = that.allAppMap;

    appidList.forEach(function(appid){
        var appitem;

        if ( allAppMap[appid] ) {
            appitem = allAppMap[appid].appitem;
        }

        if ( appitem ) {
            appitemList.push(appitem);
        }
    })

    that.appWareHouse.queryAppList({
        appidList: appidList,
        appitemList: appitemList,
        callback: function(res){
            var ret = {};

            res.forEach(function(app){
                ret[app.appid] = {
                    status: app.status,
                    progress: app.progress
                }
            })

            cbk(ret)
        }
    })


    // 批量获取游戏当前的状态
    // getAppListDetailStatus(
    //     appitemList,
    //     function(res) {
    //         for ( var appid in res ) {
    //             var progress = reStoreGameProgress(appid);
    //             res[appid] = {
    //                 status: res[appid],
    //                 progress: progress
    //             }
    //         }

    //         cbk(res);
    //     }
    // );
}

function getAppListDetailStatus(appitemList, callback) {
    var that      = this;
    appitemList = appitemList || [];

    var packageNameList = [],
        packageUrlList     = [];

    var packageNameMap = {};

    // 需要在调取jsapi后才知道
    var installedAppIdList      = [],
        unDownloadAppIdList     = [],
        downloadingAppIdList    = [],
        downloadedAppIdList     = [],
        pauseAppIdList          = [],
        waitWifiAppIdList       = [],
        updateAppIdList         = [];

    // 通过已有字段可以直接知道
    var unReserveAppIdList      = [],
        reservedAppIdList       = [],
        todoAppIdList           = [],
        tryPlayAppIdList        = [];

    // 要结合两着来看
    var h5OrNativeList          = [];   // 未决定值
    var h5AppIdList             = [];

    var needQueryAppIdList      = [];

    var appidList               = [],
        allAppMap               = {};

    appitemList.forEach(function(appitem){
        var appid = appitem.AppID;
        appidList.push(appid);
        allAppMap[appid] = appitem;
    })

    // 数据准备
    appitemList.forEach(function(appitem) {
        var appid = appitem.AppID;

        // 对简单状态可以先做筛选
        var rough_status = getRoughAppStatus(appitem);

        switch (rough_status) {
            case STATUS.un_reserve:
                unReserveAppIdList.push(appid);
                break;
            case STATUS.reserved:
                reservedAppIdList.push(appid);
                break;
            case STATUS.todo:
                todoAppIdList.push(appid);
                break;
            case STATUS.h5:
                h5AppIdList.push(appid);
                break;
            case STATUS.h5_and_app:
                h5OrNativeList.push(appid);
            default:
                if ( rough_status === STATUS.try_play ) {
                    tryPlayAppIdList.push(appid);
                }

                // 一个游戏可能有多个包名，需要都查询安装状态
                var packageList = appitem.package_name_list || [appitem.PackageName];

                packageList.forEach(function(packageName) {
                    if ( packageNameList.indexOf(packageName) == -1 ) {
                        packageNameList.push(packageName);
                        packageNameMap[packageName] = appid;
                    }
                })

                packageUrlList.push(appid + '://');

                needQueryAppIdList.push(appid);

                if ( Env.isiOS ) {
                    unDownloadAppIdList.push(appid);
                }

                break;
        }

    });

    function packStateAfterGetInstallState(res) {
        // 至少有一款游戏已安装
        // console.log(res);
        if ( res.err_msg.indexOf(':yes') > -1 ) {
            // 找出已安装的游戏
            // 安卓 res.result:[{'${packageName}': ${version}}, {'wangzhe': 1111},]  ${version} > 0时表示游戏已安装
            var resultMap = Env.isiOS ? res.result : JSON.parse(res.result);

            for ( var key in resultMap ) {
                var appVersion = resultMap[key];
                // key可能是appid:// 或 packNamge 形式（前者是ios下，后者是安卓下）
                key = key.replace(/:\/+$/g, '');    // appid:// => appid

                // ios下
                if ( appidList.indexOf(key) != -1 ) {
                    installedAppIdList.push(key)
                }

                // 安卓下
                if ( packageNameMap[key] ) {
                    var appid = packageNameMap[key];

                    if (appVersion > 0) {
                        installedAppIdList.push( appid );
                    }

                    // 虽已安装，但版本号已落后，需要放入到更新队列中
                    var localVersion = appVersion;
                    var versionCode  = allAppMap[appid].VersionCode ;

                    if (    localVersion
                        &&  versionCode
                        &&  versionCode > localVersion ) {

                        updateAppIdList.push(appid);
                        installedAppIdList.pop();
                    }
                }


            }
        }
    }

    function packStateAfterQueryDownloadTask(res) {
        for( var appidScheme in res ) {
            var appid = appidScheme.replace('://', '');
            var appRes   = res[appidScheme];

            // console.warn(appRes);
            // 已安装的可以跳过
            if ( installedAppIdList.indexOf(appid) != -1 ) {
                continue;
            }

            // 如果在H5或原生的名单中，需要区分
            if ( h5OrNativeList.indexOf(appid) != -1 ) {
                if (   (appRes.download_id == -1 || appRes.state == 'default')
                    || (appRes.state == 'download_fail')   ) {
                    h5AppIdList.push(appid)
                    continue;
                }
            }

            if ( appRes.download_id == -1 || appRes.state == 'default' ) {
                if ( appRes.reserve_for_wifi == 1 ) {
                    waitWifiAppIdList.push(appid)
                } else {
                    unDownloadAppIdList.push(appid)
                }
            }
            if ( appRes.state == 'download_succ' ) {
                downloadedAppIdList.push(appid)
            }

            if ( appRes.state == 'downloading' ) {
                downloadingAppIdList.push(appid);
            }

            if ( appRes.state == 'download_pause' ) {

                if ( appRes.reserve_for_wifi == 1 ) {
                    waitWifiAppIdList.push(appid);
                } else {
                    pauseAppIdList.push(appid)
                }
            }
            if ( appRes.state == 'download_fail' ) {
                unDownloadAppIdList.push(appid);
            }

        }
    }

    function storeQueryDownloadProgress(res) {
        for( var appidScheme in res ) {
            var appid = appidScheme.replace('://', '');
            var appRes   = res[appidScheme];
            var progress = appRes.progress;

            if ( progress && progress >= 0 ) {
                storeGameProgress({
                    appid       : appid,
                    progress    : appRes.progress
                })
            }
        }
    }

    function packFinalAppListStatus(res) {
        var ret = {};
        // 试玩和正在下载有可能是同时存在的，先后需要有优先级，本地实际状态优先
        var map = {
            installedAppIdList  : STATUS.installed,
            unDownloadAppIdList : STATUS.un_download,
            downloadingAppIdList: STATUS.downloading,
            downloadedAppIdList : STATUS.downloaded,
            updateAppIdList     : STATUS.un_update,
            waitWifiAppIdList   : STATUS.wait_wifi,
            pauseAppIdList      : STATUS.pause,
            unReserveAppIdList  : STATUS.un_reserve,
            reservedAppIdList   : STATUS.reserved,
            h5AppIdList         : STATUS.h5,
            todoAppIdList       : STATUS.todo,
            tryPlayAppIdList    : STATUS.try_play
        }
        // 从低到高
        var priorityList = [
            'unDownloadAppIdList',
            'unReserveAppIdList',
            'reservedAppIdList',
            'tryPlayAppIdList',
            'updateAppIdList',
            'downloadedAppIdList',
            'installedAppIdList',
            'pauseAppIdList',
            'waitWifiAppIdList',
            'downloadingAppIdList',
            'h5AppIdList',
            'todoAppIdList',
        ];

        // 按上面优先级更新按钮状态
        priorityList.forEach(function(listKey) {
            var appidList = res[listKey] || [];

            appidList.forEach(function(appid) {
                if ( listKey == 'unDownloadAppIdList' ) {
                    // console.warn('setapplistdetailstatus', 'un_download')
                }
                if ( listKey == '' ) {
                    // console.warn('downloadingAppIdList', 'downloading')
                }
                ret[appid] = map[listKey]

            })

        })

        return ret;


    }
    if ( Env.isAndroid ) {
        // 先获取是否是安装
        console.warn('getInstallState start', packageNameList, new Date().getTime());
        wxBridge.getInstallState({
            'packageName': packageNameList,
            'packageUrl':  packageUrlList
        },function(res) {
            // 将返回的结果按状态组整理好
            packStateAfterGetInstallState(res);

            Util.log('getInstallState end', packageNameList, new Date().getTime());

            // console.warn('queryDownload start', appidList, new Date().getTime());
            wxBridge.queryDownloadTask({
                appIdArray: appidList
            }, function(res) {
                var queryRes = {};

                Util.log('queryDownload end', appidList, new Date().getTime());

                // {err_msg: query}
                // {"result" : {'appid1://' : {"download_id" : id, "state" : state}, 'appid2://' : {"download_id" : id, "state" : state}}
                if ( res.result ) {
                    queryRes = JSON.parse(res.result);
                }


                // 将返回的结果按状态组整理好
                packStateAfterQueryDownloadTask(queryRes);

                // 将下载进度进行存储
                storeQueryDownloadProgress(queryRes);

                var ret = {
                    installedAppIdList      : installedAppIdList,
                    unDownloadAppIdList     : unDownloadAppIdList,
                    downloadingAppIdList    : downloadingAppIdList,
                    downloadedAppIdList     : downloadedAppIdList,
                    pauseAppIdList          : pauseAppIdList,
                    waitWifiAppIdList       : waitWifiAppIdList,
                    updateAppIdList         : updateAppIdList,
                    unReserveAppIdList      : unReserveAppIdList,
                    reservedAppIdList       : reservedAppIdList,
                    todoAppIdList           : todoAppIdList,
                    h5AppIdList             : h5AppIdList,
                    tryPlayAppIdList        : tryPlayAppIdList
                };


                callback( packFinalAppListStatus(ret) );
            })
        })
    } else {


        // ios下，返回当前的数组
        var ret = {
                    installedAppIdList      : installedAppIdList,
                    unDownloadAppIdList     : unDownloadAppIdList,
                    downloadingAppIdList    : downloadingAppIdList,
                    downloadedAppIdList     : downloadedAppIdList,
                    pauseAppIdList          : pauseAppIdList,
                    waitWifiAppIdList       : waitWifiAppIdList,
                    updateAppIdList         : updateAppIdList,
                    unReserveAppIdList      : unReserveAppIdList,
                    reservedAppIdList       : reservedAppIdList,
                    todoAppIdList           : todoAppIdList,
                    h5AppIdList             : h5AppIdList,
                    tryPlayAppIdList        : tryPlayAppIdList
                };


        callback(packFinalAppListStatus(ret))
    }


}


// 状态机
function AppStatusMachine(opt) {
    this.status = opt.status;
    this.appid  = opt.appid;

    this.statusChangeCbk    = opt.statusChangeCbk;
    this.progressChangeCbk  = opt.progressChangeCbk;
    this.statusReadyCbk     = opt.statusReadyCbk;
    this.statusRefreshCbk   = opt.statusRefreshCbk

    this.appitem = opt.appitem;

    this.isInited = false;
    this.isChecking = false;

    // 需要一个栈来记录状态变化
    this.stack  = [];


    // 监听jsapi触发事件
    this.listenEvent();

    return this;
}

// AppStatusMachine.prototype.initStatus = function(cbk) {
//     var that = this;


//     this.queryStatus({
//         callback: function(status){

//             that.setStatus(status);

//             that.statusReadyCbk({
//                 appid: that.appid,
//                 status: status
//             })
//         },
//         canUseCache: true
//     })

// }

// AppStatusMachine.prototype.refreshStatus = function(cbk){
//     this.queryStatus({
//         callback: function(status){

//             that.setStatus(status);

//             that.statusReadyCbk({
//                 appid: that.appid,
//                 status: status
//             })
//         },
//         canUseCache: false
//     })
// }


AppStatusMachine.prototype.queryStatus = function(opt){
    var that = this,
        appid = that.appid;
    var callback = opt.callback,
        canUseCache = typeof opt.canUseCache === 'boolean' ? opt.canUseCache : true;

    // console.warn('inited', that.isInited);
    // console.warn('ischecking', that.isChecking);

    if ( that.isStatusReady() && canUseCache ) {
        // console.warn('appstatusmachine status already', appid)
        var status = that.getStatus();

        callback(status);

        return status;
    } else  {
        // console.warn('appstatusmachine status listening ready callback', appid)
        Bus.on(KEY.queryAppStatusDone, function(res){
            // console.warn('appstatusmachine status ready callback', appid)
            if ( res.appid == appid ) {
                callback(res.status)
            }
        })

        // 去批量请求
        Bus.trigger(KEY.queryAppStatus, {
            appid: appid,
            appitem: that.appitem
        })
    }
}

AppStatusMachine.prototype.resetAppItem = function(appitem){
    var that = this;

    that.appitem = appitem;
}

AppStatusMachine.prototype.setStatusInited = function(newState) {
    var that = this,
        appid = that.appid;
    if ( this.isInited == false && newState ) {

        console.log('setStatusInited', newState)

    }

    this.isInited = newState;
}

AppStatusMachine.prototype.setStatusChecking = function(newState) {
    var that = this;
    var appid = that.appid;

    if ( this.isChecking == true && !newState ) {
        console.log('setStatusChecking', newState)
    }

    this.isChecking = newState
}

AppStatusMachine.prototype.isStatusReady = function() {
    return this.isInited && !this.isChecking;
}

AppStatusMachine.prototype.isStatusInited = function() {
    return this.isInited
}

AppStatusMachine.prototype.listenEvent = function() {
    var that = this;

    wxBridge.on('wxdownload:state_change',
        function(res) {
            var appid = res.appid,
                state = res.state;

            if ( appid != that.appid ) return;

            Util.log('wxdownload:state_change', res);

            // 下载完成
            if ( state.indexOf('_succ') > -1 ) {
                that.setStatus(STATUS.install)
            }

            // 下载暂停
            if ( state.indexOf('_pause') > -1 ) {
                if ( res.reserve_for_wifi == 1 ) {
                    that.setStatus(STATUS.wait_wifi)
                } else {
                    that.setStatus(STATUS.pause)
                }
            }

            if ( state.indexOf('_resumed') > -1 ) {
                that.setStatus(STATUS.downloading)
            }

            // 如果取消下载、下载失败、下载因无wifi自动断开，
            // 需要重新去查询游戏状态进行设置
            if (    state.indexOf('_fail') > -1
                ||  state.indexOf('_remove') > -1
                ||  state.indexOf('wifi') > -1 ) {

                that.setStatusChecking(true)
                getAppDetailStatus(
                    that.appitem,
                    function(status) {
                        that.setStatus(status);

                        that.setStatusChecking(false);
                    }
                )
            }

        }
    );
    wxBridge.on('wxdownload:progress_change',
        function(res) {
            var appid       = res.appid,
                progress    = res.progress;

            if (appid != that.appid) return;

            that.progressChangeCbk({
                appid   : appid,
                progress: progress
            })
        }
    );
    Bus.on('manualUpdate', function(ret) {
        var nextStatus = ret.nextStatus,
            appitem    = ret.appitem;

        if ( that.appid != appitem.AppID ) return;

        that.setStatus(nextStatus);
    })
    Bus.on('progressUpdate', function(res) {
        var appid    = res.appid,
            progress = res.progress;

        if ( appid != that.appid ) return;

        that.progressChangeCbk({
            appid   : appid,
            progress: progress
        })
    })

    Bus.on('manualUpdateWifi', function (ret) {
        if ( that.appid != ret.appid ) return;
        that.statusChangeCbk(ret)
    })
}

AppStatusMachine.prototype.getStatus = function() {
    return this.status;
}

AppStatusMachine.prototype.setStatus = function(status) {
    var oldStatus = this.status;


    // 如果状态是一样的，那就不设置
    if ( oldStatus == status ) {
        return;
    }

    Util.log('setStatus', {
        appid : this.appid,
        status: status,
        AppType: this.appitem.AppType,
        DownloadInfo: this.appitem.DownloadInfo
    }, this.stack);

    // 如果当前是已预约，将改为预约，不设置
    // if (   oldStatus == STATUS.reserved
    //     && status == STATUS.un_reserve   ) {
    //     return;
    // }

    this.status = status;
    this.stack.push(status);

    this.statusChangeCbk({
        appid: this.appid,
        status: status,
        oldStatus: oldStatus
    })

    if ( !this.isStatusReady() ) {

        this.setStatusInited(true)
        this.setStatusChecking(false)
    }
}


// 粗略获取当前应用的状态
function getRoughAppStatus(appitem) {
    var status = appitem.Status;
    var retStatus;

    if ( appitem.IsSubscribed ) {
        retStatus = STATUS.reserved;
    }

    switch (status) {
        case 0:
            retStatus = STATUS.un_download;
            break;
        case 1:
            // 预约
            if ( retStatus != STATUS.reserved ) {
                retStatus = STATUS.un_reserve;
            }
            break;
        case 4:
            retStatus = STATUS.try_play;
            break;
        case 5:
            retStatus = STATUS.todo;
            break;
        case 20:
            // 预约
            if ( retStatus != STATUS.reserved ) {
                retStatus = STATUS.un_reserve;
            }
            break;
        default:
            break;
    }

    // 纯H5游戏
    if ( appitem.AppType == 1 ) {
        retStatus = STATUS.h5;
    }

    if ( appitem.AppType == 2 ) {
        retStatus = STATUS.h5_and_app;
    }


    // 如果在本地里面存有状态记录
    var localStatus = reStoreGameStatus(appitem.AppID);
    if ( localStatus ) {
        // 查看缓存状态是否和粗略状态是否是互斥的，如果是，按现有粗略状态来
        if (    localStatus != retStatus
            &&  (   retStatus == STATUS.un_download
                 && (   localStatus == STATUS.downloading
                     || localStatus == STATUS.pause
                     || localStatus == STATUS.installed
                     || localStatus == STATUS.downloaded  )   )   )
        {
            retStatus = localStatus;
        }

        // if ( localStatus != retStatus
        //     && localStatus == STATUS.reserved
        //     && retStatus == STATUS.un_reserve ) {
        //     retStatus = localStatus;
        // }
    }

    return retStatus;
}

function getAppDetailStatus(appitem, cbk) {
    var retStatus = getRoughAppStatus(appitem);

    if ( Env.isAndroid ) {
        if (    retStatus == STATUS.un_reserve
            ||  retStatus == STATUS.reserved
            ||  retStatus == STATUS.todo
            ||  retStatus == STATUS.h5
        ) {
            cbk(retStatus);
        }
    }

    if ( Env.isiOS ) {
        cbk(retStatus);
        return;
    }

    wxBridge.getInstallState({
        packageName: appitem.PackageName,
        packageUrl:  appitem.AppID + '://'
    }, function(res) {
        // 已安装
        if ( res.err_msg.indexOf('yes') != -1 ) {

            retStatus = STATUS.installed;

            var localVersion = res.err_msg
			 				  ? parseInt( res.err_msg.substring(res.err_msg.lastIndexOf("_") + 1) )
							  : 0;
            var versionCode  = appitem.VersionCode;
            if (    localVersion
                &&  versionCode
                &&  versionCode > localVersion ) {
                retStatus = STATUS.un_update;
            }
        }

        // 查询状态
        wxBridge.queryDownloadTask({
            appid: appitem.AppID
        }, function(res) {
            var download_id = res.download_id,
                state       = res.state,
                progress    = res.progress || 0,
                reserve_for_wifi = res.reserve_for_wifi;

            if ( download_id == -1 || state.indexOf('default') != -1 ) {
                // 如果游戏是其他预约等状态，且没有下载安装的
                // 预防本地已经有游戏状态，但是后台返回的是预约等状态的情况
                if (    retStatus == STATUS.un_reserve
                    ||  retStatus == STATUS.reserved
                    ||  retStatus == STATUS.todo
                    ||  retStatus == STATUS.h5  ) {
                    // 保持retStatus
                    retStatus = retStatus;

                } else if (   retStatus != STATUS.installed
                    && retStatus != STATUS.un_update
                    && retStatus != STATUS.h5_and_app  ) {

                    retStatus = STATUS.un_download;
                }

                // 如果游戏没有安装，也没有下载相关状态，将会按H5游戏处理
                if ( retStatus == STATUS.h5_and_app ) {
                    retStatus = STATUS.h5
                }

                // 如果是预约wifi下载的，改为预约wifi状态
                if ( reserve_for_wifi == 1 ) {
                    retStatus = STATUS.wait_wifi
                }

            }

            if ( state.indexOf('_succ') > -1 )
                retStatus = STATUS.downloaded;

            else if ( state.indexOf('pause') > -1 ) {

                // 如果在等待wifi
                if ( reserve_for_wifi == 1 ) {
                    retStatus = STATUS.wait_wifi;
                } else {
                    retStatus = STATUS.pause;
                }

            }

            else if ( state.indexOf('downloading') > -1 )
                retStatus = STATUS.downloading;

            else if ( state.indexOf('_fail') > -1 ) {
                if (   retStatus != STATUS.installed
                    && retStatus != STATUS.un_update  ) {

                        retStatus = STATUS.un_download;
                }
            }

            if ( progress && progress >= 0) {
                storeGameProgress({
                    appid: appitem.AppID,
                    progress: progress
                })
            }

            cbk(retStatus);

        })
    })
}

Controller.STATUS = STATUS;

function isTwoAppitemSame(appitem1, appitem2) {
    var struc = {
        AppID:'xxxx',
        DownloadInfo: {
            DownloadURL: 'xx',      // 必需，后台会根据安卓或ios返回对应的下载链接
            AndroidApkMd5: 'xxx',   // 必需，安卓下载需要的md5
            AndroidApkSize: 111     // 必需，安卓下载需要包大小，用于防劫持
        },
        PackageName: 'xxx',         // 必需，包名
        AppType: 0,                 // 必需，游戏类型，用于区分纯app、H5、app混合H5
        VersionCode: 'xxx',         // 可选，后台配置最新的版本号，用于更新逻辑
        HVAppInfo: {                // 可选，H5游戏类型才需要的节点，用于拉起H5游戏
            LaunchUrl: 'xxxx'
        },
        Status: 0,
        IsSubscribed: false,
        has_sp_launch_privilege: false
    };

    try {
        for ( var key in struc ) {
            // 一层校验
            if ( JSON.stringify(appitem1[key]) != JSON.stringify(appitem2[key])) {
                return false;
            }
        }
        return true;
    } catch(e) {
        return false;
    }

}

if( Env.isiOS || Env.isAndroid){
    if ( top.window['WXGAME'] && top.window['WXGAME'].AppBtn ) {
        Util.log('top window WXGAME AppBtn ready');
        exportData = top.window['WXGAME'].AppBtn
    } else if ( window['WXGAME'] && window['WXGAME'].AppBtn ) {
        Util.log('WXGAME AppBtn ready');
        exportData = window['WXGAME'].AppBtn
    } else {
        exportData = Controller;
    }
}
}

export default exportData;
